import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';

import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import ExcelJS from 'exceljs';



import { apiUrl } from '../../../config/apiConfig';
import api from '../../../services/api';










// STYLE
import './style.css';
import { format, parseISO } from 'date-fns';

// CONTEXT API
import { useUser } from '../../../contexts/userContext';
import { useColumns } from '../../../contexts/columnsContext';

import { MdRemoveShoppingCart, MdShoppingCart, MdDoneOutline, MdDownload, MdPictureAsPdf, MdRefresh, MdBarChart, MdOutlineSearch } from "react-icons/md";

import moment from 'moment';
import Header from '../../Header';
import PreviewCard from '../../PreviewCard';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Logo from '../../../assets/logo-suite-flow.ico';
import DOMPurify from 'dompurify';

// Função para converter texto puro antigo para HTML (compatibilidade com dados antigos)
const prepareObsForDisplay = (value) => {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (str.trim() === '') return '';

  // Se já é HTML, sanitiza e retorna
  if (/<\/?[a-z][\s\S]*>/i.test(str)) {
    return DOMPurify.sanitize(str, {
      ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'blockquote'],
      ALLOWED_ATTR: ['style', 'class', 'color', 'background-color']
    });
  }

  // Se é texto puro, converte quebras de linha para <br>
  const htmlText = str.replace(/\n/g, '<br>');
  return DOMPurify.sanitize(htmlText, {
    ALLOWED_TAGS: ['br'],
    ALLOWED_ATTR: []
  });
};

// Mantém compatibilidade: converte HTML para texto puro (usado em filtros e exportações)
const obsToPlainText = (value) => {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (str.trim() === '') return '';

  // Se não parece HTML, mantém como está (preserva quebras de linha existentes)
  if (!/<\/?[a-z][\s\S]*>/i.test(str)) return str;

  try {
    // Preserva quebras típicas antes de extrair textContent
    const withBreaks = str
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<\/div>/gi, '\n')
      .replace(/<\/li>/gi, '\n');

    const doc = new DOMParser().parseFromString(withBreaks, 'text/html');
    return (doc.body.textContent || '').replace(/\u00A0/g, ' ').trim();
  } catch {
    // Fallback seguro: remove tags de forma simples
    return str.replace(/<[^>]*>/g, '').replace(/\u00A0/g, ' ').trim();
  }
};

function PCP() {
  const { user, listAllUsers, getAccessLevel } = useUser();
  const { columns, setLoadingResult, setLoadingModal, loadingResult } = useColumns();

  const [statusFilters, setStatusFilters] = useState({
    producao: ['EmAndamento'],
    medicao: ['EmAndamento'],
    vidros: ['EmAndamento'],
    vistoriaPre: ['EmAndamento'],
    entrega: ['EmAndamento'],
    instalacao: ['EmAndamento'],
    vistoriaPos: ['EmAndamento'],
    assistencia: ['EmAndamento']
  });

  const [allCards, setAllCards] = useState([]);
  const [filteredCards, setFilteredCards] = useState([]);
  const [renderedCards, setRenderedCards] = useState([]);
  const [itemsToRender, setItemsToRender] = useState(15);
  const containerRef = useRef(null);

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchClient, setSearchClient] = useState('');
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [selectedControles, setSelectedControles] = useState(['producao']);
  const [controlePlanejamento, setControlePlanejamento] = useState(['producao']);
  const [selectedEntities, setSelectedEntities] = useState(listAllUsers.map(user => user.id));

  const [openControlesModal, setOpenControlesModal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [openProcessosModal, setOpenProcessosModal] = useState(false);
  const [openResumoModal, setOpenResumoModal] = useState(false);
  const [openEntityModal, setOpenEntityModal] = useState(false);
  const [openExportModal, setOpenExportModal] = useState(false);
  const [tableKey, setTableKey] = useState(0);

  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [showPreparingModal, setShowPreparingModal] = useState(false);
  const [lastDownloadTime, setLastDownloadTime] = useState(null);

  // ✅ Filtros salvos (múltiplos)
  const [openSavedFiltersModal, setOpenSavedFiltersModal] = useState(false);
  const [savedFiltersList, setSavedFiltersList] = useState([]);
  const [selectedSavedFilterId, setSelectedSavedFilterId] = useState(null);

  // Novos estados para busca em modais
  const [searchProcessos, setSearchProcessos] = useState('');
  const [searchEntidades, setSearchEntidades] = useState('');

  const [filtersLoaded, setFiltersLoaded] = useState(false);


  useEffect(() => {
    if (columns.length > 0) {
      setSelectedColumns(columns.map(col => col.id));
    }
  }, [columns]);

  useEffect(() => {
    fetchPCP();
  }, []);

  const getColumnName = (id) => {
    const processo = columns.find(processo => processo.id === id);
    return processo ? processo.name : '';
  };

  const getDateColumnFor = (item, controle) => {
    switch (controle) {
      case 'medicao': return item.previsao_medicao;
      case 'producao': return item.previsao_producao;
      case 'vidros': return item.previsao_entrega_vidro;
      case 'vistoriaPre': return item.previsao_vistoria_pre;
      case 'entrega': return item.previsao_entrega_obra;
      case 'instalacao': return item.previsao_instalacao;
      case 'vistoriaPos': return item.previsao_vistoria_pos;
      case 'assistencia': return item.previsao_assistencia;
      default: return null;
    }
  };

  const getStatusFor = (item, controle) => {
    switch (controle) {
      case 'producao': return item.status_producao;
      case 'medicao': return item.status_medicao;
      case 'vidros': return item.status_entrega_vidro;
      case 'vistoriaPre': return item.status_vistoria_pre;
      case 'entrega': return item.status_entrega_obra;
      case 'instalacao': return item.status_instalacao;
      case 'vistoriaPos': return item.status_vistoria_pos;
      case 'assistencia': return item.status_assistencia;
      default: return null;
    }
  };

  const getColorProduct = (color) => {
    let cor = '';
    if (color === 'Branco' || color === 'BRANCO') cor = 'white';
    if (color === 'AMADEIRADO GOLDEN OAK') cor = '#916B4C';
    if (color === 'NOGUEIRA') cor = 'rgb(138, 94, 1)';
    if (color === 'PRETO LISO' || color === 'PRETO TEXTURADO') cor = 'rgb(0, 0, 0)';
    if (color === 'BRONZE') cor = '#C2B5A5';
    if (color === 'GRAFITE') cor = '#727378';
    if (color === 'PIRITA') cor = '#C7BAA2';
    if (color.includes('INTERNO BRANCO E EXTERNO')) {
      if (color.includes('AMADEIRADO GOLDEN OAK')) cor = '#916B4C';
      if (color.includes('AMADEIRADO NOGUEIRA')) cor = 'rgb(138, 94, 1)';
      if (color.includes('PRETO LISO') || color.includes('PRETO TEXTURADO')) cor = 'black';
      if (color.includes('BRONZE')) cor = '#C2B5A5';
      if (color.includes('GRAFITE')) cor = '#727378';
      if (color.includes('PIRITA')) cor = '#C7BAA2';
    }
    if (color === 'ESPECIAL') cor = 'red';
    return cor;
  };

  const getStatusCarregamentoClass = (status) => {
    switch (status) {
      case 'Sem informação':
        return 'status-carregamento-sem-info';
      case 'Carregamento programado':
        return 'status-carregamento-programado';
      case 'Aguardando Confirmação':
        return 'status-carregamento-aguardando';
      case 'Carregamento Confirmado':
        return 'status-carregamento-confirmado';
      case 'Aguardando data cliente':
        return 'status-carregamento-aguardando-cliente';
      case 'Data Confirmada pelo Cliente':
        return 'status-carregamento-data-confirmada';
      default:
        return 'status-carregamento-sem-info';
    }
  };

  const calculateDaysUntilDelivery = (deliveryDateStr) => {
    if (!deliveryDateStr) return "Data não fornecida";
    const deliveryDate = new Date(deliveryDateStr);
    if (isNaN(deliveryDate)) return "Data inválida";
    const today = new Date();
    const timeDifference = deliveryDate - today;
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return daysDifference;
  };

  const calculateDaysBetween = (startDateStr, endDateStr) => {
    if (!startDateStr || !endDateStr) return 0;
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    if (isNaN(startDate) || isNaN(endDate)) return 0;
    const diffMs = endDate.getTime() - startDate.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    return diffDays;
  };



  const handleScroll = () => {
    const container = containerRef.current;
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    if (scrollTop + clientHeight >= scrollHeight - 5) {
      loadMoreItems();
    }
  };

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [itemsToRender, filteredCards]);




  const fetchPCP = async () => {
    console.log('teste')
    if (!user || !controlePlanejamento[0]) return;

    try {
      setLoadingModal(true);
      setLoadingResult('Carregando...');

      const response = await api.get(`/card/pcp/${user.id}/${user.empresa_id}`, {
        params: {
          controle: controlePlanejamento[0],
          status: statusFilters[controlePlanejamento[0]].join(',')
        }
      });

      console.log(response.data)

      const groupedAndSortedCards = groupAndSortCardsByWeek(response.data);

      setAllCards(groupedAndSortedCards);
      setRenderedCards(groupedAndSortedCards.slice(0, itemsToRender));
      setLoadingResult('');
      setLoadingModal(false);
    } catch (error) {
      console.error('Erro ao buscar histórico:', error);
      setLoadingResult('Falha ao Carregar!!!');
      setLoadingModal(false);
    }
  };



  const groupAndSortCardsByWeek = (cards) => {
    if (!controlePlanejamento[0]) return cards;

    // Primeiro ordena os cards pela data do controle selecionado e transportador
    const sortedCards = [...cards].sort((a, b) => {
      const dateA = getDateColumnFor(a, controlePlanejamento[0]);
      const dateB = getDateColumnFor(b, controlePlanejamento[0]);

      if (!dateA && !dateB) {
        // Se ambos não têm data, ordena pelo transportador
        return (a.transportador || '').localeCompare(b.transportador || '');
      }
      if (!dateA) return 1; // Se A não tem data, vai para o final
      if (!dateB) return -1; // Se B não tem data, vai para o final

      // Compara as datas
      const dateComparison = new Date(dateA).getTime() - new Date(dateB).getTime();

      // Se as datas são iguais, ordena pelo transportador
      if (dateComparison === 0) {
        return (a.transportador || '').localeCompare(b.transportador || '');
      }

      return dateComparison;
    });

    // Depois agrupa por semana
    const groupedData = groupDataByWeek(sortedCards);

    // Transforma o objeto de semanas agrupadas em um array linear
    const orderedCards = [];
    Object.keys(groupedData).forEach(weekNumber => {
      orderedCards.push(...groupedData[weekNumber]);
    });

    return orderedCards;
  };

  const groupDataByWeek = (data) => {
    if (!controlePlanejamento[0]) return { 'sem_data': data };

    const groupedData = {};

    // Primeiro, ordena os cards pela data
    const sortedCards = [...data].sort((a, b) => {
      const dateA = getDateColumnFor(a, controlePlanejamento[0]);
      const dateB = getDateColumnFor(b, controlePlanejamento[0]);

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return new Date(dateA).getTime() - new Date(dateB).getTime();
    });

    // Depois agrupa por semana
    sortedCards.forEach((item) => {
      let dateColumn = getDateColumnFor(item, controlePlanejamento[0]);
      if (dateColumn) {
        const date = new Date(dateColumn);
        const dayOfWeek = date.getDay();
        const startOfWeek = new Date(date);
        startOfWeek.setDate(date.getDate() - (dayOfWeek - 1));
        const weekNumber = Math.floor((startOfWeek - new Date(0)) / (7 * 24 * 60 * 60 * 1000));

        if (!groupedData[weekNumber]) {
          groupedData[weekNumber] = [];
        }
        groupedData[weekNumber].push(item);
      } else {
        if (!groupedData['sem_data']) {
          groupedData['sem_data'] = [];
        }
        groupedData['sem_data'].push(item);
      }
    });

    // Ordena as semanas
    const orderedWeeks = Object.keys(groupedData).sort((a, b) => {
      if (a === 'sem_data') return 1;
      if (b === 'sem_data') return -1;
      return Number(a) - Number(b);
    });

    // Cria um novo objeto com as semanas ordenadas
    const orderedGroupedData = {};
    orderedWeeks.forEach(week => {
      orderedGroupedData[week] = groupedData[week];
    });

    return orderedGroupedData;
  };

  const normalizeDate = (dateStr) => {
    if (!dateStr) return null;
    const [year, month, day] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const applyFilters = (cards) => {
    return cards.filter(card => {
      // Filtro de cliente/pedido/documento/transportador/outro/colaboradores
      const searchTerm = searchClient.toLowerCase();
      
      let clientNameMatches = true;
      
      if (searchClient) {
        // Verifica se é uma pesquisa por colaborador (começa com @)
        if (searchTerm.startsWith('@')) {
          const colaboradorTerm = searchTerm.substring(1); // Remove o @
          
          // Filtra pelos colaboradores compartilhados
          const colaboradorMatches = card.shared_users && card.shared_users.some(sharedUser => 
            (sharedUser.shared_username && sharedUser.shared_username.toLowerCase().includes(colaboradorTerm)) ||
            (sharedUser.tipo_usuario && sharedUser.tipo_usuario.toLowerCase().includes(colaboradorTerm))
          );
          
          clientNameMatches = colaboradorMatches;
        } else if (searchTerm.startsWith('#')) {
          // Pesquisa por cor (começa com #)
          const colorTerm = searchTerm.substring(1); // Remove o #
          clientNameMatches = (card.cor && card.cor.toLowerCase().includes(colorTerm));
        } else {
          // Filtro normal (campos existentes)
          const obsPlain = obsToPlainText(card.obs);
          clientNameMatches = (
            (card.name && card.name.toLowerCase().includes(searchTerm)) ||
            (card.pedido_number && String(card.pedido_number).toLowerCase().includes(searchTerm)) ||
            (card.document_number && String(card.document_number).toLowerCase().includes(searchTerm)) ||
            (card.transportador && card.transportador.toLowerCase().includes(searchTerm)) ||
            (card.outro && card.outro.toLowerCase().includes(searchTerm)) ||
            (obsPlain && obsPlain.toLowerCase().includes(searchTerm)) ||
            (card.status_carregamento && card.status_carregamento.toLowerCase().includes(searchTerm)) ||
            (card.city && card.city.toLowerCase().includes(searchTerm))
          );
        }
      }

      // Filtro de processos
      const columnMatches = selectedColumns.includes(card.column_id);

      // Filtro de entidade
      const entityMatches = selectedEntities.length > 0 ? selectedEntities.includes(card.entity_id) : true;

      // Filtro de data baseado no controle selecionado
      const dateColumn = getDateColumnFor(card, controlePlanejamento[0]);

      // Se não tem data definida e há filtro de data, exclui o card
      if (!dateColumn && (startDate || endDate)) {
        return false;
      }

      // Se não tem data definida e não há filtro de data, inclui o card se passar nos outros filtros
      if (!dateColumn) {
        return clientNameMatches && columnMatches && entityMatches;
      }

      // Se tem data, verifica se está dentro do intervalo
      const cardDate = new Date(dateColumn);
      cardDate.setHours(0, 0, 0, 0);

      let start = null;
      let end = null;

      if (startDate) {
        // Ajuste para considerar um dia antes do início selecionado
        const [year, month, day] = startDate.split('-').map(Number);
        start = new Date(year, month - 1, day + 0);
        start.setHours(0, 0, 0, 0);
      }

      if (endDate) {
        end = new Date(endDate);
        // Ajuste para considerar um dia depois do final selecionado
        end.setDate(end.getDate() + 1);
        end.setHours(23, 59, 59, 999);
      }

      let isWithinDateRange = true;

      if (start) {
        isWithinDateRange = isWithinDateRange && cardDate.getTime() >= start.getTime();
      }

      if (end) {
        isWithinDateRange = isWithinDateRange && cardDate.getTime() <= end.getTime();
      }

      return isWithinDateRange && clientNameMatches && columnMatches && entityMatches;
    });
  };

  useEffect(() => {
    const filtered = applyFilters(allCards);
    console.log('Cards filtrados:', filtered.length);

    const groupedData = groupDataByWeek(filtered);
    console.log('Semanas agrupadas:', Object.keys(groupedData).length);

    setFilteredCards(filtered);

    // Converte o objeto de semanas em array linear para renderização
    const linearCards = [];
    Object.keys(groupedData).forEach(weekNumber => {
      linearCards.push(...groupedData[weekNumber]);
    });

    console.log('Cards lineares:', linearCards.length);
    setRenderedCards(linearCards.slice(0, itemsToRender));
  }, [allCards, searchClient, startDate, endDate, selectedColumns, statusFilters, selectedControles]);

  const loadMoreItems = () => {
    const nextItemsToRender = itemsToRender + 20;
    const groupedData = groupDataByWeek(filteredCards);

    // Converte o objeto de semanas em array linear para renderização
    const linearCards = [];
    Object.keys(groupedData).forEach(weekNumber => {
      linearCards.push(...groupedData[weekNumber]);
    });

    setRenderedCards(linearCards.slice(0, nextItemsToRender));
    setItemsToRender(nextItemsToRender);
  };





  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [controlePlanejamento]);

  const calculateWeekNumber = (dateString) => {
    if (!dateString) return { startDate: '', endDate: '' };
    const date = new Date(dateString);
    const startDate = new Date(date);
    while (startDate.getDay() !== 1) {
      startDate.setDate(startDate.getDate() - 1);
    }
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);
    const formattedStartDate = moment(startDate).format('DD/MM/YYYY');
    const formattedEndDate = moment(endDate).format('DD/MM/YYYY');
    return { startDate: formattedStartDate, endDate: formattedEndDate };
  };

  const formatDate = (dateString) => {
    const date = parseISO(dateString);
    return format(date, 'dd/MM/yyyy');
  };

const formatDateValue = (dateValue) => {
  if (!dateValue) return '';
  const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
  if (isNaN(date)) return '';
  return format(date, 'dd/MM/yyyy');
};










  const renderTableRows = (data) => {
    const getUserById = (id) => {
      const foundUser = listAllUsers.find(user => user.id === id);
      return foundUser || null;
    };

    const renderCollaborator = (sharedUser) => {
      const userDetails = getUserById(sharedUser.shared_user_id);
      const avatar = userDetails?.avatar
        ? (userDetails.avatar.includes('syncs-avatar')
          ? require(`../../../assets/avatares/${userDetails.avatar}`)
          : userDetails.avatar)
        : Logo;

      return (
        <div key={sharedUser.shared_user_id} className="colaborador-container">
          <img
            className="colaborador-avatar"
            src={avatar}
            alt={`Avatar de ${sharedUser.shared_username}`}
          />
          <div className="colaborador-info">
            <span className="colaborador-tipo">{sharedUser.tipo_usuario}</span>
            <span className="colaborador-nome">{sharedUser.shared_username}</span>
          </div>
        </div>
      );
    };
    const rows = [];
    for (const weekNumber in data) {
      if (data.hasOwnProperty(weekNumber)) {
        let weekInfo = null;
        let headerAdded = false;

        const weekItems = Array.isArray(data[weekNumber]) ? data[weekNumber] : [];

        // ✅ Calcula os totais ANTES de renderizar a semana (para poder mostrar no início e no fim)
        const weekTotals = weekItems.reduce(
          (acc, item) => {
            acc.totalHorasProducao += item?.horas_producao ? parseFloat(item.horas_producao) : 0;
            acc.totalValue += item?.cost_value ? parseFloat(item.cost_value) : 0;
            acc.totalEsquadrias += item?.quantidade_esquadrias ? parseFloat(item.quantidade_esquadrias) : 0;
            acc.totalQuadros += item?.quantidade_quadros ? parseFloat(item.quantidade_quadros) : 0;
            acc.totalMetrosQuadrados += item?.metros_quadrados ? parseFloat(item.metros_quadrados) : 0;
            const valorEtapaItem =
              item?.valor_etapa_producao && parseFloat(item.valor_etapa_producao) > 0
                ? parseFloat(item.valor_etapa_producao)
                : (item?.cost_value ? parseFloat(item.cost_value) : 0);
            acc.totalValorEtapa += valorEtapaItem;
            return acc;
          },
          {
            totalHorasProducao: 0,
            totalValue: 0,
            totalValorEtapa: 0,
            totalEsquadrias: 0,
            totalQuadros: 0,
            totalMetrosQuadrados: 0,
          }
        );

        // Helper para reutilizar a MESMA linha de totais (início e fim) sem risco de divergência
        const pushTotalsRow = (position) => {
          rows.push(
            <tr key={`week-row-total-${position}-${weekNumber}`}>
              <td style={{ backgroundColor: 'white', color: 'white' }} ></td>
              <td style={{ backgroundColor: 'white', color: 'white' }} ></td>
              <td style={{ backgroundColor: 'white', color: 'white' }} ></td>
              <td style={{ backgroundColor: 'white', color: 'white' }} ></td>
              <td style={{ backgroundColor: 'white', color: 'white' }} ></td>
              <td style={{ backgroundColor: 'white', color: 'white' }} ></td>
              <td style={{ backgroundColor: 'white', color: 'white' }} ></td>
              <td style={{ backgroundColor: 'white', color: 'white' }} ></td>
              <td style={{ backgroundColor: 'white', color: 'white' }} ></td>
              {getAccessLevel('valor') &&
                <td style={{ backgroundColor: '#9862FF', color: 'white' }}>
                  <label className='horas-totais-label'>
                    {parseFloat(weekTotals.totalValue ? weekTotals.totalValue : 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </label>
                </td>
              }
              {getAccessLevel('valor') &&
                <td style={{ backgroundColor: '#9862FF', color: 'white' }}>
                  <label className='horas-totais-label'>
                    {parseFloat(weekTotals.totalValorEtapa ? weekTotals.totalValorEtapa : 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </label>
                </td>
              }
              <td style={{ backgroundColor: '#9820FF', color: 'white' }} >
                <label className='horas-totais-label'>{weekTotals.totalHorasProducao.toFixed(0)}</label>
              </td>
              <td style={{ backgroundColor: '#9862FF', color: 'white' }}>
                <label className='horas-totais-label'>{weekTotals.totalEsquadrias.toFixed(0)}</label>
              </td>
              <td style={{ backgroundColor: '#9820FF', color: 'white' }} >
                <label className='horas-totais-label'>{weekTotals.totalQuadros.toFixed(0)}</label>
              </td>
              <td style={{ backgroundColor: '#9862FF', color: 'white' }}>
                <label className='horas-totais-label'>{weekTotals.totalMetrosQuadrados.toFixed(0)}</label>
              </td>
              <td style={{ backgroundColor: 'white', color: 'white' }} ></td>
              <td style={{ backgroundColor: 'white', color: 'white' }} ></td>
            </tr>
          );
        };

        // Se for a semana 'sem_data', não mostra o cabeçalho de semana
        if (weekNumber !== 'sem_data') {
          const correctDate = getDateColumnFor(weekItems[0], controlePlanejamento[0]);
          weekInfo = calculateWeekNumber(correctDate);
          if (weekInfo == null) return;
          if (weekInfo.startDate && weekInfo.endDate) {
            rows.push(
              <tr key={`week-header-${weekNumber}`}>
                <td className='semana-container' colSpan="21">
                  <label className='semana-label'>{`( ${weekInfo.startDate} - ${weekInfo.endDate} )`}</label>
                </td>
              </tr>
            );
          }
        } else {
          // Cabeçalho para cards sem data
          rows.push(
            <tr key="week-header-sem-data">
              <td className='semana-container' colSpan="21">
                <label className='semana-label'>Sem data definida</label>
              </td>
            </tr>
          );
        }

        if (!headerAdded) {
          const controleLabel = controlePlanejamento[0] ? controlePlanejamento[0].charAt(0).toUpperCase() + controlePlanejamento[0].slice(1) : '';
          rows.push(
            <tr key={`week-columns-header-${weekNumber}`} className='header-semana-title'>
              <th style={{ width: '310px' }}>Card</th>
              <th>Cor</th>
              <th style={{ width: '310px' }}>Observações</th>
              <th>Processo</th>
              <th>Transportador</th>
              <th>Confirmação</th>
              <th style={{ display: 'none' }}>Pedido</th>
              <th>{controleLabel}</th>
              <th>Entrega</th>
              <th style={{ width: '200px' }} >Colaboradores</th>
              <th style={{ display: 'none' }}>Representante</th>
              {getAccessLevel('valor') &&
                <th>Valor</th>
              }
              {getAccessLevel('valor') &&
                <th>Valor Etapa</th>
              }
              <th>Horas</th>
              <th>Esquadrias</th>
              <th>Quadros</th>
              <th>m2</th>
              <th>Dias de Produção</th>
              <th>Prazo</th>
              <th>Vidro</th>
            </tr>
          );
          headerAdded = true;

          // ✅ NOVO: Totais da semana logo no início (abaixo do header roxo)
          pushTotalsRow('inicio');
        }

        weekItems.forEach((item) => {
          let previsaoData = getDateColumnFor(item, controlePlanejamento[0]);
          rows.push(
            <tr key={item.id}>
              <td className='icon-status-controle'>
                <PreviewCard cardData={item} />
                <div className={getStatusCarregamentoClass(item.status_carregamento || 'Sem informação')} style={{ marginTop: '5px' }}>
                  <span className="status-carregamento-badge">
                    {item.status_carregamento || 'Sem informação'}
                  </span>
                </div>
              </td>
              <td style={{ fontSize: '10px', color: `black` }}>
                <div className='color-container-ref'>
                  <div style={{ fontSize: '11px', color: item.cor === 'BRANCO' ? `black` : `white`, background: `${getColorProduct(item.cor)}` }} className='color-ref'></div>
                  {item.cor}
                </div>
              </td>
              <td 
                style={{ fontSize: '12px', textAlign: 'center' }}
                className="obs-cell-rich-text"
                dangerouslySetInnerHTML={{ __html: prepareObsForDisplay(item.obs) }}
              />
              <td style={{ fontSize: '12px' }}>{getColumnName(item.column_id)}</td>
              <td style={{ fontSize: '12px' }}>{item.transportador || ''}</td>
              <td style={{ fontSize: '12px' }}>{item.outro || ''}</td>
              <td style={{ fontSize: '12px', display: 'none' }}>{item.numero_pedido ? item.numero_pedido : ''}</td>
              <td style={{ fontSize: '12px' }}>
                {previsaoData ? formatDate(previsaoData) : ''}
              </td>
              <td style={{ fontSize: '12px' }}>
                {item.previsao_entrega_obra ? formatDate(item.previsao_entrega_obra) : ''}

              </td>
              <td >
                {item.shared_users && item.shared_users.map(user => renderCollaborator(user))}
              </td>
              <td style={{ fontSize: '12px', display: 'none' }}>{getUsernameById(item.entity_id).substring(0, 15)}</td>
              {getAccessLevel('valor') &&
                <td style={{ fontSize: '12px' }}>{parseFloat(item.cost_value ? item.cost_value : 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
              }
              {getAccessLevel('valor') && (
                <td style={{ fontSize: '12px' }}>
                  {(
                    (item.valor_etapa_producao && parseFloat(item.valor_etapa_producao) > 0)
                      ? parseFloat(item.valor_etapa_producao)
                      : parseFloat(item.cost_value ? item.cost_value : 0)
                  ).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                </td>
              )}
              <td style={{ fontSize: '12px' }}>{item.horas_producao ? item.horas_producao : 0}</td>
              <td style={{ fontSize: '12px' }}>{item.quantidade_esquadrias ? item.quantidade_esquadrias : 0}</td>
              <td style={{ fontSize: '12px' }}>{item.quantidade_quadros ? item.quantidade_quadros : 0}</td>
              <td style={{ fontSize: '12px' }}>{item.metros_quadrados ? item.metros_quadrados : 0}</td>
              <td style={{ fontSize: '12px' }}>
                {calculateDaysBetween(item.previsao_medicao, item.previsao_entrega_obra)}
              </td>
              <td style={{ fontSize: '12px' }}>{item.prazo_entrega ? calculateDaysUntilDelivery(item.prazo_entrega) : 0} dias</td>
              <td style={{ fontSize: '12px' }}>
                <div className='vidro-container'>
                  <div className='status-vidro'>
                    {item.status_entrega_vidro === 'Parado' ? (
                      <MdRemoveShoppingCart className='icon-status-vidro-comprar' />
                    ) : <></>}
                    {item.status_entrega_vidro === 'EmAndamento' ? (
                      <MdShoppingCart className='icon-status-vidro-comprado' />
                    ) : <></>}
                    {item.status_entrega_vidro === 'Pronto' ? (
                      <MdDoneOutline className='icon-status-vidro-entergue' />
                    ) : <></>}
                  </div>
                  {item.entrega_vidro}
                </div>
              </td>
            </tr>
          );
        });
        // Totais da semana no fim (mantém exatamente o comportamento anterior)
        pushTotalsRow('fim');
        rows.push(
          <div className='linha-vazia-programacao'></div>
        );
      }
    }
    return rows;
  };





  const getUsernameById = (id) => {
    const user = listAllUsers.find(user => user.id === id);
    return user ? user.username : 'Usuário não encontrado';
  };










  // // Função para exportar os dados para Excel
  // const exportToExcel = (data) => {
  //   const worksheet = XLSX.utils.json_to_sheet(
  //     data.map((item) => ({
  //       Cliente: item.name,
  //       Pedido: item.numero_pedido,
  //       Documento: item.document_number,
  //       Transportador: item.transportador,
  //       Outro: item.outro,
  //       Processo: getColumnName(item.column_id),
  //       Status: getStatusFor(item, controlePlanejamento[0]),
  //       Previsão: getDateColumnFor(item, controlePlanejamento[0]) ? formatDate(getDateColumnFor(item, controlePlanejamento[0])) : '',
  //       Colaboradores: item.shared_users ? item.shared_users.map(user => `${user.tipo_usuario}: ${user.shared_username}`).join('\r\n') : '',
  //       Representante: getUsernameById(item.entity_id),
  //       Valor: item.cost_value ? parseFloat(item.cost_value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '',
  //       Horas: item.horas_producao ? item.horas_producao : 0,
  //       Esquadrias: item.quantidade_esquadrias ? item.quantidade_esquadrias : 0,
  //       Quadros: item.quantidade_quadros ? item.quantidade_quadros : 0,
  //       'm²': item.metros_quadrados ? item.metros_quadrados : 0,
  //       Cor: item.cor,
  //       Observações: item.obs,
  //       'Status Medição': item.status_medicao,
  //       'Status Produção': item.status_producao,
  //       'Status Vidros': item.status_entrega_vidro,
  //       'Status Vistoria Pré': item.status_vistoria_pre,
  //       'Status Entrega': item.status_entrega_obra,
  //       'Status Instalação': item.status_instalacao,
  //       'Status Vistoria Pós': item.status_vistoria_pos,
  //       'Status Assistência': item.status_assistencia,
  //       'Previsão Medição': item.previsao_medicao ? formatDate(item.previsao_medicao) : '',
  //       'Previsão Produção': item.previsao_producao ? formatDate(item.previsao_producao) : '',
  //       'Previsão Vidros': item.previsao_entrega_vidro ? formatDate(item.previsao_entrega_vidro) : '',
  //       'Previsão Vistoria Pré': item.previsao_vistoria_pre ? formatDate(item.previsao_vistoria_pre) : '',
  //       'Previsão Entrega': item.previsao_entrega_obra ? formatDate(item.previsao_entrega_obra) : '',
  //       'Previsão Instalação': item.previsao_instalacao ? formatDate(item.previsao_instalacao) : '',
  //       'Previsão Vistoria Pós': item.previsao_vistoria_pos ? formatDate(item.previsao_vistoria_pos) : '',
  //       'Previsão Assistência': item.previsao_assistencia ? formatDate(item.previsao_assistencia) : '',
  //       'Entrega Vidro': item.entrega_vidro,
  //       'Prazo Entrega': item.previsao_entrega_obra ? calculateDaysUntilDelivery(item.previsao_entrega_obra) + ' dias' : '0 dias'
  //     }))
  //   );

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'PCP');

  //   const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //   const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });

  //   saveAs(dataBlob, 'PCP.xlsx');
  // };




  const exportFilteredToExcel = async (includeHistory = false) => {
    try {
      setShowPreparingModal(true);
      setLoadingResult('Preparando dados para exportação...');

      // Pequeno delay para mostrar o modal
      await new Promise(resolve => setTimeout(resolve, 500));

      setLoadingResult('Criando planilha com ExcelJS...');

      // Criar workbook com ExcelJS
      const workbook = new ExcelJS.Workbook();
      workbook.creator = 'SyncsCRM';
      workbook.created = new Date();

      // Criar worksheet principal
      const worksheet = workbook.addWorksheet('PCP - Dados Formatados', {
        pageSetup: { paperSize: 9, orientation: 'landscape' }
      });

      // Função para converter número da coluna para letra Excel - ANTES das instruções
      const getExcelColumnName = (columnNumber) => {
        let columnName = '';
        while (columnNumber > 0) {
          const remainder = (columnNumber - 1) % 26;
          columnName = String.fromCharCode(65 + remainder) + columnName;
          columnNumber = Math.floor((columnNumber - 1) / 26);
        }
        return columnName;
      };

      // Definir cabeçalhos (condicional para histórico) - ANTES das instruções
      const baseHeaders = [
        'Processo', 'Pedido', 'Doc Secundário', 'Cliente', 'Cor', 
        'Qtd Quadros', 'Cidade', 'Estado', 'Prev Medição', 'Status Medição',
        'Prev Produção', 'Status Produção', 'Prev Vidro', 'Status Vidro',
        'Prev Vistoria Pré', 'Status Vistoria Pré', 'Prev Entrega', 'Status Entrega',
        'Prev Instalação', 'Status Instalação', 'Prev Vistoria Pós', 'Status Vistoria Pós',
        'Prev Assistência', 'Status Assistência', 'Horas Produção', 'Observações',
        'Qtd Esquadrias', 'Metros²', 'Responsável', 'Valor', 'Valor Etapa',
        'Prazo Entrega', 'Status Prazo', 'Transportador', 'Colaboradores', 'Outro',
        'Data Lib. Financeiro', 'Data Assin. Contrato', 'Data Lib. Produção', 'Status Carregamento'
      ];
      
      const headers = includeHistory ? [...baseHeaders, 'Histórico'] : baseHeaders;

      // Criar aba de instruções
      const instrucoes = workbook.addWorksheet('📋 Como Usar Filtros');
      
      // Adicionar instruções na segunda aba
      instrucoes.addRow(['📋 MANUAL COMPLETO - FILTROS E ORDENAÇÃO PCP']);
      instrucoes.addRow([]);
      instrucoes.addRow(['🚀 OPÇÕES DE EXPORTAÇÃO:']);
      instrucoes.addRow(['   • RÁPIDA: Sem histórico (35 colunas) - Processamento mais rápido']);
      instrucoes.addRow(['   • COMPLETA: Com histórico (36 colunas) - Inclui histórico detalhado']);
      instrucoes.addRow([]);
      instrucoes.addRow(['🎯 PASSO A PASSO PARA FILTRAR:']);
      instrucoes.addRow([]);
      instrucoes.addRow([`1️⃣ COMO FILTRAR (TODAS as ${headers.length} colunas têm filtro):`]);
      instrucoes.addRow(['   • Vá para aba "PCP - Dados Formatados"']);
      instrucoes.addRow([`   • Você verá SETAS em TODAS as colunas (A até ${getExcelColumnName(headers.length)})`]);
      instrucoes.addRow(['   • Clique na SETA ao lado do nome da coluna que quer filtrar']);
      instrucoes.addRow(['   • Desmarque "(Selecionar Tudo)" e marque apenas os itens desejados']);
      instrucoes.addRow(['   • Clique OK para aplicar o filtro']);
      instrucoes.addRow([`   • IMPORTANTE: Funciona em todas as ${headers.length} colunas${includeHistory ? ' incluindo HISTÓRICO!' : '!'}`]);
      instrucoes.addRow([]);
      instrucoes.addRow(['2️⃣ COMO ORDENAR (para ver próximas atividades):']);
      instrucoes.addRow(['   • Clique na SETA da coluna de data']);
      instrucoes.addRow(['   • Escolha "Classificar do Menor para o Maior" (datas mais próximas primeiro)']);
      instrucoes.addRow([]);
      instrucoes.addRow(['🏗️ COLUNAS IMPORTANTES PARA ORDENAR:']);
      instrucoes.addRow(['   • Coluna I (Prev Medição) → Ver próximas medições']);
      instrucoes.addRow(['   • Coluna K (Prev Produção) → Ver próximas produções']);
      instrucoes.addRow(['   • Coluna Q (Prev Entrega) → Ver próximas entregas']);
      instrucoes.addRow(['   • Coluna S (Prev Instalação) → Ver próximas instalações']);
      instrucoes.addRow(['   • Coluna AJ (Data Lib. Financeiro) → Ver liberações financeiras']);
      instrucoes.addRow(['   • Coluna AK (Data Assin. Contrato) → Ver assinaturas de contrato']);
      instrucoes.addRow(['   • Coluna AL (Data Lib. Produção) → Ver liberações para produção']);
      if (includeHistory) {
        instrucoes.addRow([`   • Coluna ${getExcelColumnName(headers.length)} (Histórico) → Ver todo histórico do card`]);
      }
      instrucoes.addRow([]);
      instrucoes.addRow(['🎨 CORES DA PLANILHA (Visual):']);
      instrucoes.addRow(['   🌈 CORES ALTERNADAS = Facilita leitura das colunas']);
      instrucoes.addRow(['   📊 CABEÇALHO AZUL = Identificação dos títulos']);
      instrucoes.addRow(['   📋 RESUMO DESTACADO = Totais na última linha']);
      instrucoes.addRow([]);
      instrucoes.addRow(['📜 NOVA COLUNA DE HISTÓRICO (AJ):']);
      instrucoes.addRow(['   ✅ Contém TODAS as movimentações do card']);
      instrucoes.addRow(['   ✅ Data e hora de cada ação realizada']);
      instrucoes.addRow(['   ✅ Tipo de ação (criação, edição, mudança de status)']);
      instrucoes.addRow(['   ✅ Descrição detalhada de cada movimentação']);
      instrucoes.addRow(['   ✅ Status do card em cada momento']);
      instrucoes.addRow(['   ✅ Permite filtrar por texto específico do histórico']);
      instrucoes.addRow([]);
      instrucoes.addRow(['💡 EXEMPLOS PRÁTICOS DE FILTROS:']);
      instrucoes.addRow(['   📍 Obras de SP: Filtrar coluna "Estado" = SP']);
      instrucoes.addRow(['   ⏰ Produções pendentes: Filtrar "Status Produção" = Pendente']);
      instrucoes.addRow(['   🏢 Cliente específico: Filtrar coluna "Cliente"']);
      instrucoes.addRow(['   👥 Colaboradores: Filtrar coluna "Colaboradores" por nome ou tipo']);
      instrucoes.addRow(['   📋 Buscar no histórico: Filtrar coluna "Histórico" por texto específico']);
      instrucoes.addRow(['   💰 Liberação financeira: Filtrar coluna "Data Lib. Financeiro"']);
      instrucoes.addRow(['   📝 Contratos assinados: Filtrar coluna "Data Assin. Contrato"']);
      instrucoes.addRow(['   🏭 Liberado para produção: Filtrar coluna "Data Lib. Produção"']);
      instrucoes.addRow(['   🔄 Combinar filtros: Estado=SP + Status=Pendente + Cidade=São Paulo']);
      instrucoes.addRow([]);
      instrucoes.addRow(['📊 RESUMO DOS DADOS (Linha Final):']);
      instrucoes.addRow(['   ✅ Total de Obras: Quantidade total de registros']);
      instrucoes.addRow(['   ✅ Total Quadros: Soma de todos os quadros (Coluna F)']);
      instrucoes.addRow(['   ✅ Total Horas: Soma de todas as horas de produção (Coluna Y)']);
      instrucoes.addRow(['   ✅ Total Esquadrias: Soma de todas as esquadrias (Coluna AA)']);
      instrucoes.addRow(['   ✅ Total M²: Soma de todos os metros quadrados (Coluna AB)']);
      instrucoes.addRow(['   ✅ Total Valor: Soma de todos os valores em R$ (Coluna AD)']);
      instrucoes.addRow([]);
      instrucoes.addRow(['⚡ DICAS ESPECIAIS:']);
      instrucoes.addRow(['   📌 FILTRO POR COLABORADOR NO SISTEMA:']);
      instrucoes.addRow(['   Use @ + nome no campo de pesquisa (ex: @João, @Instalador)']);
      instrucoes.addRow(['   ']);
      instrucoes.addRow(['   📅 OBRAS QUE PRECISAM DE AÇÃO HOJE:']);
      instrucoes.addRow(['   1. Ordene por "Prev Produção" (menor para maior)']);
      instrucoes.addRow(['   2. Analise as datas mais próximas (topo da lista)']);
      instrucoes.addRow(['   3. Combine filtros por status para ver pendências']);
      
      // Formatação das instruções (ajustado para as novas linhas do histórico)
      instrucoes.getRow(1).font = { size: 16, bold: true, color: { argb: 'FF4472C4' } }; // Título principal
      instrucoes.getRow(3).font = { size: 14, bold: true, color: { argb: 'FF008000' } }; // PASSO A PASSO
      instrucoes.getRow(5).font = { size: 12, bold: true, color: { argb: 'FF0066CC' } }; // 1️⃣ COMO FILTRAR
      instrucoes.getRow(13).font = { size: 12, bold: true, color: { argb: 'FF0066CC' } }; // 2️⃣ COMO ORDENAR
      instrucoes.getRow(17).font = { size: 12, bold: true, color: { argb: 'FFFF6600' } }; // 🏗️ COLUNAS IMPORTANTES
      instrucoes.getRow(24).font = { size: 12, bold: true, color: { argb: 'FFCC6600' } }; // 🎨 CORES AUTOMÁTICAS
      instrucoes.getRow(28).font = { size: 12, bold: true, color: { argb: 'FF9932CC' } }; // 📜 NOVA COLUNA DE HISTÓRICO
      instrucoes.getRow(36).font = { size: 12, bold: true, color: { argb: 'FF009900' } }; // 💡 EXEMPLOS PRÁTICOS
      instrucoes.getRow(43).font = { size: 12, bold: true, color: { argb: 'FF6600CC' } }; // 📊 RESUMO DOS DADOS
      instrucoes.getRow(50).font = { size: 12, bold: true, color: { argb: 'FFFF0066' } }; // ⚡ DICA ESPECIAL
      
      // Adicionar altura às linhas importantes (ajustado para incluir histórico)
      instrucoes.getRow(1).height = 30; // Título
      instrucoes.getRow(3).height = 25; // Subtítulos
      instrucoes.getRow(5).height = 20;
      instrucoes.getRow(13).height = 20;
      instrucoes.getRow(17).height = 20;
      instrucoes.getRow(24).height = 20;
      instrucoes.getRow(28).height = 20; // Nova seção de histórico
      instrucoes.getRow(36).height = 20;
      instrucoes.getRow(43).height = 20;
      instrucoes.getRow(50).height = 20;
      
      // Deixar coluna bem larga para as instruções
      instrucoes.getColumn(1).width = 100;
      
      // Centralizar todas as células das instruções
      instrucoes.eachRow((row) => {
        row.eachCell((cell) => {
          if (!cell.font) cell.font = {};
          cell.alignment = {
            horizontal: 'left', // Instruções ficam melhor alinhadas à esquerda
            vertical: 'middle',
            wrapText: true
          };
        });
      });



      // Adicionar cabeçalhos à planilha
      console.log(`📋 Headers definidos: ${headers.length} colunas`);
      console.log(`📋 Últimas 3 colunas:`, headers.slice(-3));
      console.log(`📋 Coluna ${headers.length}: "${headers[headers.length - 1]}"`);
      
      const headerRow = worksheet.addRow(headers);
      console.log(`✅ Headers adicionados ao worksheet - Linha criada com ${headerRow.cellCount} células`);
      
      // Verificar se a última célula tem o valor correto
      const lastCell = headerRow.getCell(headers.length);
      console.log(`🔍 Última célula (${headers.length}): "${lastCell.value}"`);
      
      if (lastCell.value !== 'Histórico') {
        console.error(`❌ ERRO: Última célula deveria ser "Histórico" mas é "${lastCell.value}"`);
      } else {
        console.log(`✅ SUCESSO: Coluna Histórico criada corretamente na posição ${headers.length}`);
      }

      setLoadingResult('Aplicando cores e formatação...');

      // Cores alternadas para colunas
      const coresColunas = [
        'FFCCCB', // Rosa claro
        'ADD8E6', // Azul claro
        '90EE90', // Verde claro
        'FFE4B5', // Laranja claro
        'DDA0DD', // Roxo claro
        'AFEEEE', // Turquesa claro
        'FFFFE0', // Amarelo claro
        'F0F0F0'  // Cinza claro
      ];

      // Formatação do cabeçalho
      headerRow.eachCell((cell, colNumber) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF4472C4' } // Azul escuro
        };
        cell.font = {
          name: 'Calibri',
          size: 11,
          bold: true,
          color: { argb: 'FFFFFFFF' } // Branco
        };
        cell.alignment = {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true
        };
        cell.border = {
          top: { style: 'medium', color: { argb: 'FF000000' } },
          left: { style: 'thin', color: { argb: 'FF000000' } },
          bottom: { style: 'medium', color: { argb: 'FF000000' } },
          right: { style: 'thin', color: { argb: 'FF000000' } }
        };
      });

      // Definir larguras das colunas (condicional para histórico)
      const baseColumnWidths = [25, 15, 18, 30, 20, 12, 15, 10, 15, 15, 15, 15, 15, 15, 18, 18, 15, 15, 16, 16, 18, 18, 16, 16, 14, 35, 15, 16, 20, 15, 15, 14, 15, 20, 40, 20, 18, 18, 18, 25];
      const columnWidths = includeHistory ? [...baseColumnWidths, 50] : baseColumnWidths;
      
      columnWidths.forEach((width, index) => {
        worksheet.getColumn(index + 1).width = width;
      });

      setLoadingResult('Adicionando dados...');

      // Log de verificação inicial
      console.log(`📊 Iniciando exportação com ${filteredCards.length} cards`);
      if (filteredCards.length > 0) {
        console.log(`🔍 Primeiro card - ID: ${filteredCards[0].card_id || filteredCards[0].id}, Nome: ${filteredCards[0].name}`);
      }

      // 🧪 MODO DEBUG: Processar apenas os primeiros 5 cards para teste
      const isDebugMode = false; // Mudei para false para processar todos
      const cardsToProcess = isDebugMode ? filteredCards.slice(0, 5) : filteredCards;
      console.log(`🔧 Modo Debug: ${isDebugMode ? 'ATIVO' : 'INATIVO'} - Processando ${cardsToProcess.length} cards`);
      
      // Mensagem inicial
      if (isDebugMode && filteredCards.length > 5) {
        setLoadingResult(`MODO DEBUG: Processando apenas ${cardsToProcess.length} cards de ${filteredCards.length}`);
      } else {
        setLoadingResult(`Iniciando exportação de ${cardsToProcess.length} cards com histórico...`);
      }

      // Função para buscar histórico do card
      const getCardHistory = async (cardId) => {
        try {
          if (!cardId) {
            console.warn(`⚠️ Card ID inválido: ${cardId}`);
            return [];
          }
          const response = await api.get(`/card/history/${cardId}`);
          return response.data || [];
        } catch (error) {
          console.error(`❌ Erro ao buscar histórico do card ${cardId}:`, error.response?.data || error.message);
          return [];
        }
      };

      // Função para pequena pausa (evita sobrecarga da API)
      const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

      // Função para formatar histórico em texto legível
      const formatHistory = (history) => {
        if (!history || history.length === 0) {
          return 'Nenhum histórico disponível';
        }
        
        try {
          return history.map(item => {
            const date = item.create_at ? new Date(item.create_at).toLocaleString('pt-BR') : 'Data não disponível';
            const action = item.action_type || 'Ação não especificada';
            const description = item.description || '';
            const status = item.card_status || 'N/A';
            return `${date}: ${action} - ${description} (Status: ${status})`;
          }).join('\n');
        } catch (error) {
          console.error('Erro ao formatar histórico:', error);
          return 'Erro ao formatar histórico';
        }
      };

      // Adicionar dados com formatação
      for (let rowIndex = 0; rowIndex < cardsToProcess.length; rowIndex++) {
        const item = cardsToProcess[rowIndex];
        
        // Verificar se o card tem ID válido
        if (!item.card_id && !item.id) {
          console.warn(`⚠️ Card sem ID na linha ${rowIndex + 1}:`, item);
        }
        
        let formattedHistory = '';
        
        // Buscar histórico do card apenas se solicitado
        if (includeHistory) {
          setLoadingResult(`Buscando histórico... Linha ${rowIndex + 1} de ${cardsToProcess.length}`);
          const cardId = item.card_id || item.id; // Tentar ambos os campos
          const cardHistory = await getCardHistory(cardId);
          formattedHistory = formatHistory(cardHistory);
          
          // Log de debug apenas para o primeiro card
          if (rowIndex === 0) {
            console.log(`🧪 Primeiro card - ID: ${cardId}, Nome: ${item.name}`);
            console.log(`📝 Histórico formatado (${formattedHistory.length} chars): ${formattedHistory.substring(0, 50)}...`);
          }
          
          // Pequena pausa para evitar sobrecarga da API (apenas a cada 10 registros)
          if ((rowIndex + 1) % 10 === 0) {
            await delay(100); // 100ms de pausa a cada 10 registros
          }
        } else {
          setLoadingResult(`Processando dados... Linha ${rowIndex + 1} de ${cardsToProcess.length}`);
        }
        
        const colaboradores = item.shared_users 
          ? item.shared_users.map(user => `${user.tipo_usuario}: ${user.shared_username}`).join(' | ')
          : '';

        const baseRowData = [
          getColumnName(item.column_id),
          item.pedido_number || '',
          item.second_document_number || '',
          item.name || '',
          item.cor || '',
          item.quantidade_quadros || 0,
          item.city || '',
          item.state || '',
          item.previsao_medicao ? formatDate(item.previsao_medicao) : '',
          item.status_medicao || '',
          item.previsao_producao ? formatDate(item.previsao_producao) : '',
          item.status_producao || '',
          item.previsao_entrega_vidro ? formatDate(item.previsao_entrega_vidro) : '',
          item.status_entrega_vidro || '',
          item.previsao_vistoria_pre ? formatDate(item.previsao_vistoria_pre) : '',
          item.status_vistoria_pre || '',
          item.previsao_entrega_obra ? formatDate(item.previsao_entrega_obra) : '',
          item.status_entrega_obra || '',
          item.previsao_instalacao ? formatDate(item.previsao_instalacao) : '',
          item.status_instalacao || '',
          item.previsao_vistoria_pos ? formatDate(item.previsao_vistoria_pos) : '',
          item.status_vistoria_pos || '',
          item.previsao_assistencia ? formatDate(item.previsao_assistencia) : '',
          item.status_assistencia || '',
          item.horas_producao || 0,
          obsToPlainText(item.obs),
          item.quantidade_esquadrias || 0,
          item.metros_quadrados || 0,
          getUsernameById(item.entity_id),
          item.cost_value ? parseFloat(item.cost_value) : 0,
          // Valor Etapa - mesma lógica da tabela (exporta como número puro)
          (item.valor_etapa_producao && parseFloat(item.valor_etapa_producao) > 0)
            ? parseFloat(item.valor_etapa_producao)
            : parseFloat(item.cost_value || 0),
          item.prazo_entrega || '',
          item.status_prazo_entrega || '',
          item.transportador || '',
          colaboradores,
          item.outro || '',
          item.data_liberacao_financeiro ? formatDate(item.data_liberacao_financeiro) : '',
          item.data_assinatura_contrato ? formatDate(item.data_assinatura_contrato) : '',
          item.data_liberacao_producao ? formatDate(item.data_liberacao_producao) : '',
          item.status_carregamento || 'Sem informação'
        ];
        
        const rowData = includeHistory ? [...baseRowData, formattedHistory] : baseRowData;

        // Log de verificação apenas para o primeiro card
        if (rowIndex === 0) {
          console.log(`📊 RowData: ${rowData.length} colunas (esperado: ${headers.length})`);
          if (rowData.length !== headers.length) {
            console.error(`❌ ERRO: Número de colunas não confere! RowData: ${rowData.length}, Headers: ${headers.length}`);
          }
        }

        const dataRow = worksheet.addRow(rowData);
        
        // Log apenas para o primeiro card
        if (rowIndex === 0) {
          console.log(`📊 Primeira linha adicionada ao worksheet com ${dataRow.cellCount} células`);
          const historicoCell = dataRow.getCell(headers.length);
          console.log(`🔍 Célula de histórico (${headers.length}): "${String(historicoCell.value).substring(0, 50)}..."`);
        }

        // Definir altura da linha para 40
        dataRow.height = 40;

        // Aplicar formatação para cada célula da linha
        dataRow.eachCell((cell, colNumber) => {
          const corIndex = (colNumber - 1) % coresColunas.length;
          
          // Coluna 39 é Status Carregamento (ou 40 se tiver histórico)
          const isStatusCarregamentoColumn = colNumber === 39;
          const statusCarregamento = item.status_carregamento || 'Sem informação';
          
          // Definir cores específicas para Status Carregamento
          let corStatus = 'FFFFFFFF'; // Branco padrão
          let corTextoStatus = 'FF000000'; // Preto padrão
          
          if (isStatusCarregamentoColumn) {
            switch (statusCarregamento) {
              case 'Sem informação':
                corStatus = 'FF9E9E9E'; // Cinza
                corTextoStatus = 'FFFFFFFF'; // Branco
                break;
              case 'Carregamento programado':
                corStatus = 'FF2196F3'; // Azul
                corTextoStatus = 'FFFFFFFF'; // Branco
                break;
              case 'Aguardando Confirmação':
                corStatus = 'FFFFC107'; // Amarelo
                corTextoStatus = 'FF333333'; // Preto
                break;
              case 'Carregamento Confirmado':
                corStatus = 'FF4CAF50'; // Verde
                corTextoStatus = 'FFFFFFFF'; // Branco
                break;
              case 'Aguardando data cliente':
                corStatus = 'FFFF9800'; // Laranja
                corTextoStatus = 'FFFFFFFF'; // Branco
                break;
              case 'Data Confirmada pelo Cliente':
                corStatus = 'FF1B5E20'; // Verde Escuro
                corTextoStatus = 'FFFFFFFF'; // Branco
                break;
            }
          }
          
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: isStatusCarregamentoColumn ? corStatus : ('FF' + coresColunas[corIndex]) }
          };
          
          cell.font = {
            name: 'Calibri',
            size: 10,
            color: { argb: isStatusCarregamentoColumn ? corTextoStatus : 'FF000000' },
            bold: isStatusCarregamentoColumn ? true : false
          };

          // Centralizar TODOS os conteúdos, mas histórico fica alinhado à esquerda
          const isHistoryColumn = includeHistory && colNumber === headers.length;
          cell.alignment = {
            horizontal: isHistoryColumn ? 'left' : 'center', // Histórico alinhado à esquerda
            vertical: 'middle',
            wrapText: colNumber === 26 || colNumber === 34 || isHistoryColumn // Wrap para observações, colaboradores e histórico
          };

          cell.border = {
            top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
            left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
            bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
            right: { style: 'thin', color: { argb: 'FFCCCCCC' } }
          };


        });

        // Atualizar progresso a cada 10 linhas
        if ((rowIndex + 1) % 10 === 0) {
          const percent = Math.round(((rowIndex + 1) / cardsToProcess.length) * 100);
          setLoadingResult(`Processando ${rowIndex + 1}/${cardsToProcess.length} cards (${percent}%) com histórico...`);
        }
      }

      setLoadingResult('Aplicando configurações finais...');

      // Altura da linha do cabeçalho
      headerRow.height = 40;

      setLoadingResult('Configurando filtros e ordenação...');



      // Configurações avançadas de filtro - TODAS as colunas disponíveis
      const ultimaColuna = getExcelColumnName(headers.length);
      worksheet.autoFilter = {
        from: 'A1',
        to: `${ultimaColuna}${cardsToProcess.length + 1}`
      };

      console.log(`AutoFilter configurado de A1 até ${ultimaColuna}${cardsToProcess.length + 1} (${headers.length} colunas)`);

      // Congelar primeira linha
      worksheet.views = [
        { state: 'frozen', ySplit: 1 }
      ];

      // Adicionar ordenação padrão por "Prev Produção" (coluna 11)
      // Isso ajuda a ver as próximas obras a produzir primeiro
      try {
        worksheet.getColumn(11).sort = 'asc'; // Ordenação crescente por data de produção
      } catch (e) {
        console.log('Ordenação automática não suportada nesta versão do ExcelJS');
      }

      // Adicionar linha de resumo no final
      setLoadingResult('Adicionando resumo de dados...');
      
      const ultimaLinhaComDados = filteredCards.length + 1; // Linha dos dados (depois do header)
      
      // Calcular totais via JavaScript (mais confiável que fórmulas Excel)
      let totalQuadros = 0;
      let totalHoras = 0;
      let totalEsquadrias = 0;
      let totalM2 = 0;
      let totalValor = 0;
      let totalValorEtapa = 0;
      
      cardsToProcess.forEach(item => {
        totalQuadros += parseInt(item.quantidade_quadros) || 0;
        totalHoras += parseFloat(item.horas_producao) || 0;
        totalEsquadrias += parseInt(item.quantidade_esquadrias) || 0;
        totalM2 += parseFloat(item.metros_quadrados) || 0;
        totalValor += parseFloat(item.cost_value) || 0;
        
        // Calcular Valor Etapa - mesma lógica da tabela
        const valorEtapaItem = item.valor_etapa_producao && parseFloat(item.valor_etapa_producao) > 0
          ? parseFloat(item.valor_etapa_producao)
          : parseFloat(item.cost_value || 0);
        totalValorEtapa += valorEtapaItem;
      });

      const resumoRow = worksheet.addRow([
        '📊 RESUMO GERAL',
        '',
        '',
        `${cardsToProcess.length} obras`,
        '',
        totalQuadros, // F - Total quadros
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        totalHoras.toFixed(1), // Y - Total horas
        '',
        totalEsquadrias, // AA - Total esquadrias  
        totalM2.toFixed(2), // AB - Total M²
        '',
        totalValor.toFixed(2), // AD - Total valor
        totalValorEtapa.toFixed(2), // AE - Total valor etapa
        '',
        '',
        '',
        '',
        '',
        '', // Data Lib. Financeiro
        '', // Data Assin. Contrato
        '', // Data Lib. Produção
        '' // Status Carregamento (vazio no resumo)
      ]);

      // Adicionar linha de separação antes do resumo
      const separadorRow = worksheet.addRow(['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']);
      separadorRow.height = 10;
      
      // Formatação da linha de resumo
      resumoRow.height = 40;
      resumoRow.eachCell((cell, colNumber) => {
        // Destacar apenas células com conteúdo
        const celulasComConteudo = [1, 4, 6, 25, 27, 28, 30, 31]; // Posições com totais
        
        if (celulasComConteudo.includes(colNumber)) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF2F5F8F' } // Azul escuro
          };
          cell.font = {
            name: 'Calibri',
            size: 12,
            bold: true,
            color: { argb: 'FFFFFFFF' }
          };
        } else {
          // Células vazias com fundo cinza claro
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFF0F0F0' } // Cinza bem claro
          };
        }
        
        cell.alignment = {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true
        };
        
        // Bordas grossas para destacar
        cell.border = {
          top: { style: 'thick', color: { argb: 'FF000000' } },
          left: { style: 'thick', color: { argb: 'FF000000' } },
          bottom: { style: 'thick', color: { argb: 'FF000000' } },
          right: { style: 'thick', color: { argb: 'FF000000' } }
        };
      });

      // Formatação específica para números nas colunas numéricas
      worksheet.getColumn(6).numFmt = '#,##0'; // Quantidade quadros
      worksheet.getColumn(25).numFmt = '#,##0.00'; // Horas produção
      worksheet.getColumn(27).numFmt = '#,##0'; // Quantidade esquadrias
      worksheet.getColumn(28).numFmt = '#,##0.00'; // Metros quadrados
      worksheet.getColumn(30).numFmt = 'R$ #,##0.00'; // Valor
      worksheet.getColumn(31).numFmt = 'R$ #,##0.00'; // Valor Etapa

      // Formatação de data para colunas de previsão
      const colunasData = [9, 11, 13, 15, 17, 19, 21, 23, 32, 37, 38, 39]; // Incluindo prazo entrega e os 3 novos campos
      colunasData.forEach(colNum => {
        worksheet.getColumn(colNum).numFmt = 'dd/mm/yyyy';
      });

      setLoadingResult('Gerando arquivo Excel...');

      // Verificação final antes de gerar o arquivo
      console.log(`🔍 Verificação final do worksheet:`);
      console.log(`📊 Total de linhas: ${worksheet.rowCount}`);
      console.log(`📊 Total de colunas: ${worksheet.columnCount}`);
      
      // Verificar se a coluna de histórico existe
      const lastColumnHeader = worksheet.getCell(1, headers.length).value;
      console.log(`🔍 Última coluna do header: "${lastColumnHeader}"`);
      
      if (lastColumnHeader === 'Histórico') {
        console.log(`✅ CONFIRMADO: Coluna Histórico existe na posição ${headers.length}`);
      } else {
        console.error(`❌ PROBLEMA: Coluna Histórico não encontrada! Valor encontrado: "${lastColumnHeader}"`);
      }

      // Gerar arquivo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      // Nome do arquivo
      const now = new Date();
      const timestamp = now.toLocaleString('pt-BR').replace(/[/:]/g, '-').replace(/,/g, '');
      const fileName = `PCP_Formatado_ExcelJS_${timestamp}.xlsx`;

      saveAs(blob, fileName);

      setLoadingResult(`🎉 Excel criado com ${cardsToProcess.length} cards! ✅ HISTÓRICO INCLUÍDO + Filtros + Resumo + Manual!`);
      setTimeout(() => {
        setShowPreparingModal(false);
        setLoadingResult('');
      }, 2500);

    } catch (error) {
      console.error('❌ ERRO DETALHADO ao exportar com ExcelJS:', error);
      console.error('❌ Stack trace:', error.stack);
      console.error('❌ Mensagem:', error.message);
      
      // Verificar se o erro aconteceu durante a busca do histórico
      if (error.message && error.message.includes('history')) {
        console.error('❌ Erro relacionado ao histórico detectado');
      }
      
      setLoadingResult(`❌ Erro ao gerar planilha: ${error.message}`);
      setTimeout(() => {
        setShowPreparingModal(false);
        setLoadingResult('');
      }, 5000);
    }
  };









  // Funções auxiliares para exportação
  const exportWithHistory = () => {
    setOpenExportModal(false);
    exportFilteredToExcel(true);
  };

  const exportWithoutHistory = () => {
    setOpenExportModal(false);
    exportFilteredToExcel(false);
  };

  const exportWeeklySchedule = async () => {
    if (!controlePlanejamento[0]) return;
    try {
      setShowPreparingModal(true);
      setLoadingResult('Preparando agenda semanal...');
      await new Promise(resolve => setTimeout(resolve, 300));

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Agenda Semanal', {
        pageSetup: { paperSize: 9, orientation: 'portrait' }
      });

      const controlesLabel = controlePlanejamento.length
        ? controlePlanejamento.map(getControleLabel).join(', ')
        : 'N/D';
      const periodoLabel = `${startDate ? formatDateValue(startDate) : 'Início não definido'} - ${endDate ? formatDateValue(endDate) : 'Fim não definido'}`;
      const pesquisaLabel = searchClient ? searchClient : 'Sem pesquisa';

      const filtrosTexto = `Filtros aplicados: Controles: ${controlesLabel} | Período: ${periodoLabel} | Pesquisa: ${pesquisaLabel}`;

      const filtersRow = worksheet.addRow([filtrosTexto]);
      filtersRow.height = 30;
      worksheet.mergeCells(`A${filtersRow.number}:G${filtersRow.number}`);
      const firstCell = filtersRow.getCell(1);
      firstCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE8F0FE' }
      };
      firstCell.font = { name: 'Calibri', size: 11, bold: true, color: { argb: 'FF000000' } };
      firstCell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
      firstCell.border = {
        top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
        left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
        bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
        right: { style: 'thin', color: { argb: 'FFCCCCCC' } }
      };

      const headers = ['Instalação', 'Dia da Semana', 'Pedido', 'Cliente', 'Cidade', 'Metros²', 'Transportador'];
      const headerRow = worksheet.addRow(headers);
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF4472C4' }
        };
        cell.font = { name: 'Calibri', size: 11, bold: true, color: { argb: 'FFFFFFFF' } };
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        cell.border = {
          top: { style: 'medium', color: { argb: 'FF000000' } },
          left: { style: 'thin', color: { argb: 'FF000000' } },
          bottom: { style: 'medium', color: { argb: 'FF000000' } },
          right: { style: 'thin', color: { argb: 'FF000000' } }
        };
      });
      headerRow.height = 30;

      const getDayLabel = (dateObj) => {
        const labels = ['DOMINGO', 'SEGUNDA', 'TERÇA', 'QUARTA', 'QUINTA', 'SEXTA', 'SÁBADO'];
        return labels[dateObj.getDay()];
      };

      const normalizeDate = (value) => {
        if (!value) return null;
        const d = value instanceof Date ? new Date(value) : new Date(value);
        if (isNaN(d)) return null;
        d.setHours(0, 0, 0, 0);
        return d;
      };

      const addBusinessDay = (date) => {
        if (!date) return null;
        const result = new Date(date);
        result.setDate(result.getDate() + 1);
        const day = result.getDay();
        // Sábado -> pula para segunda (+2), Domingo -> pula para segunda (+1)
        if (day === 6) {
          result.setDate(result.getDate() + 2);
        } else if (day === 0) {
          result.setDate(result.getDate() + 1);
        }
        return result;
      };

      const getDateRange = () => {
        let min = startDate ? normalizeDate(startDate) : null;
        let max = endDate ? normalizeDate(endDate) : null;

        filteredCards.forEach((card) => {
          const dateStr = getDateColumnFor(card, controlePlanejamento[0]);
          const cardDate = addBusinessDay(normalizeDate(dateStr));
          if (!cardDate) return;
          if (!min || cardDate < min) min = cardDate;
          if (!max || cardDate > max) max = cardDate;
        });

        const fallback = normalizeDate(new Date());
        return {
          min: min || fallback,
          max: max || fallback
        };
      };

      const { min, max } = getDateRange();

      const isSameDay = (a, b) => {
        return a && b && a.getTime() === b.getTime();
      };

      const dayRows = [];
      for (let d = new Date(min); d <= max; d.setDate(d.getDate() + 1)) {
        const currentDate = new Date(d);
        currentDate.setHours(0, 0, 0, 0);
        const cardsForDay = filteredCards.filter((card) => {
          const dateStr = getDateColumnFor(card, controlePlanejamento[0]);
          const cardDate = addBusinessDay(normalizeDate(dateStr));
          return isSameDay(cardDate, currentDate);
        });

        if (cardsForDay.length === 0) {
          dayRows.push({
            date: currentDate,
            entries: [{ pedido: '', cliente: '', cidade: '', metros: '', transportador: '' }]
          });
        } else {
          const entries = cardsForDay.map((card) => ({
            pedido: card.pedido_number || card.numero_pedido || '',
            cliente: card.name || '',
            cidade: card.city || '',
            metros: card.metros_quadrados || '',
            transportador: card.transportador || ''
          }));
          dayRows.push({ date: currentDate, entries });
        }
      }

      dayRows.forEach(({ date, entries }) => {
        const isWeekend = date.getDay() === 0 || date.getDay() === 6;
        entries.forEach((entry, idx) => {
          const row = worksheet.addRow([
            idx === 0 ? formatDateValue(date) : '',
            idx === 0 ? getDayLabel(date) : '',
            entry.pedido,
            entry.cliente,
            entry.cidade,
            entry.metros,
            entry.transportador
          ]);

          row.eachCell((cell, colNumber) => {
            const baseColor = isWeekend ? 'FFF6D8CE' : 'FFFFFFFF';
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: baseColor }
            };
            cell.alignment = {
              horizontal: colNumber === 3 || colNumber === 4 ? 'left' : 'center',
              vertical: 'middle',
              wrapText: true
            };
            cell.border = {
              top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
              left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
              bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
              right: { style: 'thin', color: { argb: 'FFCCCCCC' } }
            };
            if (colNumber === 6) {
              cell.numFmt = '#,##0.00';
            }
          });
          row.height = 30;
        });
      });

      worksheet.columns = [
        { width: 15 }, // Instalação
        { width: 16 }, // Dia da Semana
        { width: 12 }, // Pedido
        { width: 45 }, // Cliente
        { width: 18 }, // Cidade
        { width: 12 }, // Metros²
        { width: 18 }  // Transportador
      ];

      worksheet.views = [{ state: 'frozen', ySplit: 1 }];

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const now = new Date();
      const timestamp = now.toLocaleString('pt-BR').replace(/[/:]/g, '-').replace(/,/g, '');
      saveAs(blob, `PCP_Agenda_Semanal_${timestamp}.xlsx`);

      setLoadingResult('Agenda semanal gerada com sucesso!');
      setTimeout(() => {
        setShowPreparingModal(false);
        setLoadingResult('');
      }, 2000);
    } catch (error) {
      console.error('Erro ao exportar agenda semanal:', error);
      setLoadingResult('Erro ao gerar agenda semanal.');
      setTimeout(() => {
        setShowPreparingModal(false);
        setLoadingResult('');
      }, 3000);
    }
  };

  const exportFilteredToPDFWithPdfLib = async () => {
    if (!controlePlanejamento[0]) return;

    try {
      setShowPreparingModal(true);
      setLoadingResult('Preparando dados para PDF...');

      // Pequeno delay para mostrar o modal
      await new Promise(resolve => setTimeout(resolve, 500));

      setLoadingResult('Gerando documento PDF...');

    const pdfDoc = await PDFDocument.create();
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
      const fontSize = 7;
      const margin = 20;
      const lineHeight = 35;  // Aumentado para caber até 3 linhas de conteúdo
      
      // Colunas otimizadas para usar máximo da largura da folha (800px disponíveis)
      // Adicionado coluna de Previsão de Carregamento (após Estado) e removido Local Estoque
      const colWidths = [55, 65, 120, 70, 50, 55, 40, 70, 140, 85];
    const pageHeight = 595;
    const pageWidth = 842;
      
    const headers = [
        'Pedido', 'Prefsuite', 'Cliente', 'Cor', 'Quadros', 
        'Cidade', 'Estado', 'Carregamento', 'Observações', 'Transportador'
    ];

    let page = pdfDoc.addPage([pageWidth, pageHeight]);
    let y = pageHeight - margin;

    const drawHeader = () => {
      let x = margin;
      
      // Desenhar fundo do cabeçalho
      page.drawRectangle({
        x: margin,
        y: y - lineHeight,
        width: colWidths.reduce((sum, width) => sum + width, 0),
        height: lineHeight,
        color: rgb(0.95, 0.95, 0.98),
        borderColor: rgb(0.8, 0.8, 0.8),
        borderWidth: 0.5,
      });
      
      // Desenhar borda esquerda do cabeçalho
      page.drawLine({
        start: { x: margin, y: y },
        end: { x: margin, y: y - lineHeight },
        thickness: 0.5,
        color: rgb(0.8, 0.8, 0.8),
      });
      
      headers.forEach((header, i) => {
        // Desenhar borda vertical entre colunas (exceto a primeira)
        if (i > 0) {
          page.drawLine({
            start: { x: x, y: y },
            end: { x: x, y: y - lineHeight },
            thickness: 0.5,
            color: rgb(0.8, 0.8, 0.8),
          });
        }
        
        page.drawText(sanitizeText(header), {
          x: x + 3,
          y: y - (lineHeight / 2) - 3,
            size: fontSize + 2,
          font,
          color: rgb(0.1, 0.1, 0.7),
        });
        x += colWidths[i];
      });
      
      // Borda direita da última coluna
      page.drawLine({
        start: { x: x, y: y },
        end: { x: x, y: y - lineHeight },
        thickness: 0.5,
        color: rgb(0.8, 0.8, 0.8),
      });
      
        y -= lineHeight + 5;
    };

    // Função para sanitizar texto e evitar erros de encoding
    const sanitizeText = (text) => {
      if (!text) return '';
      return String(text)
        .replace(/[\r\n\t]/g, ' ')  // Remove quebras de linha, carriage return e tabs
        .replace(/\s+/g, ' ')       // Substitui múltiplos espaços por um único
        .replace(/[^\x20-\x7E\u00C0-\u00FF]/g, '')  // Remove caracteres não ASCII
        .trim();
    };

    // Função para quebrar texto em múltiplas linhas respeitando a largura
    const wrapText = (text, maxWidth) => {
      if (!text) return [''];
      
      // Garantir que o texto está completamente limpo
      const cleanText = sanitizeText(text);
      const words = cleanText.split(' ').filter(word => word.length > 0);
      
      if (words.length === 0) return [''];
      
      const lines = [];
      let currentLine = '';
      
      for (const word of words) {
        const testLine = currentLine ? `${currentLine} ${word}` : word;
        
        try {
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) {
              lines.push(currentLine);
              currentLine = word;
            } else {
              // Palavra muito longa, cortar
              let truncatedWord = word;
              while (truncatedWord.length > 3 && font.widthOfTextAtSize(truncatedWord + '...', fontSize) > maxWidth) {
                truncatedWord = truncatedWord.slice(0, -1);
              }
              lines.push(truncatedWord + (truncatedWord !== word ? '...' : ''));
            }
          }
        } catch (error) {
          console.warn('Erro ao calcular largura do texto:', error);
          // Em caso de erro, adicionar o texto sem verificação de largura
          if (currentLine) {
            lines.push(currentLine);
            currentLine = word;
          } else {
            lines.push(word);
          }
        }
      }
      
      if (currentLine) {
        lines.push(currentLine);
      }
      
      // Limitar a 3 linhas e garantir que não há strings vazias
      return lines.slice(0, 3).filter(line => line && line.trim().length > 0);
    };

    const drawRow = (row) => {
      let x = margin;
      
      // Desenhar fundo alternado para as linhas (muito sutil)
      const isEvenRow = Math.floor((pageHeight - y) / lineHeight) % 2 === 0;
      const backgroundColor = isEvenRow ? rgb(1, 1, 1) : rgb(0.98, 0.98, 0.99);
      
      // Fundo da linha completa
      page.drawRectangle({
        x: margin,
        y: y - lineHeight,
        width: colWidths.reduce((sum, width) => sum + width, 0),
        height: lineHeight,
        color: backgroundColor,
      });
      
      // Desenhar borda esquerda da tabela
      page.drawLine({
        start: { x: margin, y: y },
        end: { x: margin, y: y - lineHeight },
        thickness: 0.3,
        color: rgb(0.85, 0.85, 0.85),
      });
      
      row.forEach((cell, i) => {
        // Desenhar borda vertical entre colunas (exceto a primeira)
        if (i > 0) {
          page.drawLine({
            start: { x: x, y: y },
            end: { x: x, y: y - lineHeight },
            thickness: 0.3,
            color: rgb(0.85, 0.85, 0.85),
          });
        }
        
        const sanitizedText = sanitizeText(cell);
        const maxWidth = colWidths[i] - 8; // Mais margem para as bordas
        const lines = wrapText(sanitizedText, maxWidth);
        
        // Desenhar cada linha da célula
        lines.forEach((line, lineIndex) => {
          if (!line || line.trim().length === 0) return; // Skip empty lines
          
          const lineY = y - 8 - (lineIndex * 10); // Ajustado para margem da borda
          
          // Dupla sanitização para garantir segurança
          const finalText = sanitizeText(line);
          
          try {
            page.drawText(finalText, {
              x: x + 3, // Margem da borda esquerda
              y: lineY,
              size: fontSize,
              font,
              color: rgb(0, 0, 0),
            });
          } catch (error) {
            console.warn(`Erro ao desenhar texto: "${finalText}":`, error);
            // Em caso de erro, tentar desenhar uma versão ainda mais limpa
            const safeFallback = finalText.replace(/[^\x20-\x7E]/g, '?');
            try {
              page.drawText(safeFallback, {
                x: x + 3,
                y: lineY,
                size: fontSize,
                font,
                color: rgb(0, 0, 0),
              });
            } catch (fallbackError) {
              console.error('Erro crítico ao desenhar texto:', fallbackError);
            }
          }
        });

        x += colWidths[i];
      });
      
      // Borda direita da última coluna
      page.drawLine({
        start: { x: x, y: y },
        end: { x: x, y: y - lineHeight },
        thickness: 0.3,
        color: rgb(0.85, 0.85, 0.85),
      });
      
      // Borda horizontal inferior da linha
      page.drawLine({
        start: { x: margin, y: y - lineHeight },
        end: { x: x, y: y - lineHeight },
        thickness: 0.3,
        color: rgb(0.85, 0.85, 0.85),
      });
      
      y -= lineHeight;
    };

    // Título
      page.drawText(sanitizeText(`Relatório PCP - Dados de Produção`), {
      x: margin,
      y,
      size: 16,
      font,
      color: rgb(0, 0, 0),
    });
    y -= 25;

      // Informações do filtro
      const totais = getTotaisFiltrados();
      page.drawText(sanitizeText(`Total de registros: ${totais.totalObras} | Período: ${totais.menorData} até ${totais.maiorData}`), {
        x: margin,
        y,
        size: 9,
        font,
        color: rgb(0.2, 0.2, 0.2),
    });
    y -= 20;

    drawHeader();
    
    // Desenhar borda superior da tabela
    const tableWidth = colWidths.reduce((sum, width) => sum + width, 0);
    page.drawLine({
      start: { x: margin, y: y + lineHeight + 5 },
      end: { x: margin + tableWidth, y: y + lineHeight + 5 },
      thickness: 0.5,
      color: rgb(0.8, 0.8, 0.8),
    });

      setLoadingResult('Processando registros...');

      for (let i = 0; i < filteredCards.length; i++) {
        const item = filteredCards[i];
        
        // Atualiza progresso a cada 50 registros
        if (i % 50 === 0) {
          setLoadingResult(`Processando registro ${i + 1} de ${filteredCards.length}...`);
          await new Promise(resolve => setTimeout(resolve, 10));
        }

        if (y < margin + lineHeight + 20) {
        page = pdfDoc.addPage([pageWidth, pageHeight]);
        y = pageHeight - margin;
          
          // Título na nova página
          page.drawText(sanitizeText(`Relatório PCP - Dados de Produção (continuação)`), {
          x: margin,
          y,
          size: 14,
          font,
          color: rgb(0, 0, 0),
        });
          y -= 30;

        drawHeader();
        
        // Desenhar borda superior da tabela na nova página
        const tableWidth = colWidths.reduce((sum, width) => sum + width, 0);
        page.drawLine({
          start: { x: margin, y: y + lineHeight + 5 },
          end: { x: margin + tableWidth, y: y + lineHeight + 5 },
          thickness: 0.5,
          color: rgb(0.8, 0.8, 0.8),
        });
      }

      const row = [
          item.pedido_number || '',
          item.second_document_number || '',
          item.name || '',
          item.cor || '',
          item.quantidade_quadros || '0',
          item.city || '',
          item.state || '',
          item.previsao_entrega_obra ? formatDate(item.previsao_entrega_obra) : '',
          obsToPlainText(item.obs),
          item.transportador || ''
      ];

      drawRow(row);
    }

      // Rodapé com totais
      y -= 25;
      page.drawText(sanitizeText(`Totais: ${totais.totalObras} obras | ${totais.totalQuadros} quadros | Período: ${totais.menorData} a ${totais.maiorData}`), {
        x: margin,
        y,
        size: 9,
        font,
        color: rgb(0.4, 0.4, 0.4),
      });

      setLoadingResult('Finalizando PDF...');

    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      
      // Nome do arquivo com data e hora
      const now = new Date();
      const timestamp = now.toLocaleString('pt-BR').replace(/[/:]/g, '-').replace(/,/g, '');
      const fileName = `PCP_Dados_${timestamp}.pdf`;
      
      saveAs(blob, fileName);

      setLoadingResult('Download concluído com sucesso!');
      setTimeout(() => {
        setShowPreparingModal(false);
        setLoadingResult('');
      }, 1500);

    } catch (error) {
      console.error('Erro ao exportar PDF:', error);
      setLoadingResult('Erro ao gerar PDF. Tente novamente.');
      setTimeout(() => {
        setShowPreparingModal(false);
        setLoadingResult('');
      }, 3000);
    }
  };


  const getTotaisFiltrados = () => {
    let totalHoras = 0;
    let totalQuadros = 0;
    let totalEsquadrias = 0;
    let totalM2 = 0;
    let totalValor = 0;
    let totalValorEtapa = 0;
    let totalObras = filteredCards.length;
    let menorData = null;
    let maiorData = null;
    let semanas = new Set();

    filteredCards.forEach(item => {
      const dataControle = getDateColumnFor(item, controlePlanejamento[0]);
      if (dataControle) {
        const data = new Date(dataControle);
        if (!menorData || data < menorData) {
          menorData = data;
        }
        if (!maiorData || data > maiorData) {
          maiorData = data;
        }

        // Calcula a semana do ano
        const inicioSemana = new Date(data);
        inicioSemana.setDate(data.getDate() - data.getDay() + 1);
        const semanaKey = inicioSemana.toISOString().split('T')[0];
        semanas.add(semanaKey);
      }

      totalHoras += parseFloat(item.horas_producao || 0);
      totalQuadros += parseFloat(item.quantidade_quadros || 0);
      totalEsquadrias += parseFloat(item.quantidade_esquadrias || 0);
      totalM2 += parseFloat(item.metros_quadrados || 0);
      totalValor += parseFloat(item.cost_value || 0);
      const valorEtapaItem = item.valor_etapa_producao && parseFloat(item.valor_etapa_producao) > 0
        ? parseFloat(item.valor_etapa_producao)
        : parseFloat(item.cost_value || 0);
      totalValorEtapa += valorEtapaItem;
    });

    return {
      totalHoras,
      totalQuadros,
      totalEsquadrias,
      totalM2,
      totalValor,
      totalValorEtapa,
      totalObras,
      totalSemanas: semanas.size,
      menorData: menorData ? moment(menorData).format('DD/MM/YYYY') : 'Não definida',
      maiorData: maiorData ? moment(maiorData).format('DD/MM/YYYY') : 'Não definida'
    };
  };

  const handleControleSelection = (controle) => {
    if (controlePlanejamento.includes(controle)) {
      setControlePlanejamento(controlePlanejamento.filter(c => c !== controle));
    } else {
      setControlePlanejamento([...controlePlanejamento, controle]);
    }
  };

  const getControleLabel = (controle) => {
    switch (controle) {
      case 'medicao': return 'Medição';
      case 'producao': return 'Produção';
      case 'vidros': return 'Vidros';
      case 'vistoriaPre': return 'Vistoria Pré';
      case 'entrega': return 'Previsão de Entrega';
      case 'instalacao': return 'Instalação';
      case 'vistoriaPos': return 'Vistoria Pós';
      case 'assistencia': return 'Assistência';
      default: return controle;
    }
  };

  // Adiciona um useEffect para resetar a rolagem quando as datas mudam
  useEffect(() => {
    setItemsToRender(15);
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [startDate, endDate]);

  useEffect(() => {
    // Mostrar o modal após 60 segundos quando o componente é montado
    const initialTimeout = setTimeout(() => {
      setShowDownloadModal(true);
    }, 60000); // 60 segundos

    return () => {
      clearTimeout(initialTimeout);
    };
  }, []); // Executa apenas uma vez quando o componente é montado

  // Efeito separado para controlar o intervalo de 30 minutos após fechar o modal
  useEffect(() => {
    if (!showDownloadModal && lastDownloadTime) {
      const thirtyMinutesTimeout = setTimeout(() => {
        setShowDownloadModal(true);
        setLastDownloadTime(new Date());
      }, 30 * 60000); // 30 minutos

      return () => {
        clearTimeout(thirtyMinutesTimeout);
      };
    }
  }, [showDownloadModal, lastDownloadTime]);















  // =========================
  // Filtros salvos (múltiplos)
  // =========================
  const PCP_SAVED_FILTERS_KEY = 'pcpSavedFilters_v1';
  const PCP_LEGACY_FILTER_KEY = 'pcpFilters'; // compatibilidade (antigo)

  const buildCurrentFiltersPayload = () => ({
    statusFilters,
    selectedColumns,
    selectedControles,
    controlePlanejamento,
    selectedEntities,
    startDate,
    endDate,
    searchClient
  });

  const safeJsonParse = (value, fallback) => {
    try {
      if (!value) return fallback;
      return JSON.parse(value);
    } catch {
      return fallback;
    }
  };

  const getSavedFiltersStore = () => {
    const raw = localStorage.getItem(PCP_SAVED_FILTERS_KEY);
    const parsed = safeJsonParse(raw, null);
    if (!parsed || typeof parsed !== 'object') return { version: 1, items: [] };
    if (!Array.isArray(parsed.items)) return { version: 1, items: [] };
    return { version: 1, items: parsed.items };
  };

  const setSavedFiltersStore = (items) => {
    localStorage.setItem(PCP_SAVED_FILTERS_KEY, JSON.stringify({ version: 1, items }));
  };

  const getLegacyFilterItem = () => {
    const legacyRaw = localStorage.getItem(PCP_LEGACY_FILTER_KEY);
    const legacyParsed = safeJsonParse(legacyRaw, null);
    if (!legacyParsed) return null;
    return {
      id: '__legacy__',
      name: 'Filtro antigo (único)',
      filters: legacyParsed,
      isLegacy: true,
      createdAt: null,
      updatedAt: null,
    };
  };

  const refreshSavedFiltersList = () => {
    const store = getSavedFiltersStore();
    const legacyItem = getLegacyFilterItem();
    const items = store.items || [];
    const normalized = legacyItem ? [legacyItem, ...items] : items;

    setSavedFiltersList(normalized);
    setSelectedSavedFilterId((prev) => {
      if (prev && normalized.some(i => i.id === prev)) return prev;
      return normalized[0]?.id || null;
    });
  };

  const applyFiltersPayload = (payload) => {
    if (!payload || typeof payload !== 'object') return;
    const {
      statusFilters,
      selectedColumns,
      selectedControles,
      controlePlanejamento,
      selectedEntities,
      startDate,
      endDate,
      searchClient
    } = payload;

    if (statusFilters) setStatusFilters(statusFilters);
    if (selectedColumns) setSelectedColumns(selectedColumns);
    if (selectedControles) setSelectedControles(selectedControles);
    if (controlePlanejamento) setControlePlanejamento(controlePlanejamento);
    if (selectedEntities) setSelectedEntities(selectedEntities);
    if (startDate !== undefined) setStartDate(startDate);
    if (endDate !== undefined) setEndDate(endDate);
    if (searchClient !== undefined) setSearchClient(searchClient);

    setFiltersLoaded(true); // 🔥 Ativa o efeito para buscar os cards
  };

  const saveFiltersToLocalStorage = () => {
    const name = window.prompt('Digite um nome para o filtro:', '');
    if (name === null) return; // cancelado
    const trimmed = String(name).trim();
    if (!trimmed) return alert('Nome do filtro inválido. Tente novamente.');

    const filters = buildCurrentFiltersPayload();
    const store = getSavedFiltersStore();
    const nowIso = new Date().toISOString();

    const existingIndex = store.items.findIndex((i) => (i?.name || '').toLowerCase() === trimmed.toLowerCase());
    const nextItems = [...store.items];

    if (existingIndex >= 0) {
      const overwrite = window.confirm(`Já existe um filtro chamado "${trimmed}". Deseja sobrescrever?`);
      if (!overwrite) return;
      const prev = nextItems[existingIndex] || {};
      nextItems[existingIndex] = {
        ...prev,
        name: trimmed,
        filters,
        updatedAt: nowIso,
        createdAt: prev.createdAt || nowIso,
      };
    } else {
      nextItems.unshift({
        id: `${Date.now()}_${Math.random().toString(16).slice(2)}`,
        name: trimmed,
        filters,
        createdAt: nowIso,
        updatedAt: nowIso,
      });
    }

    setSavedFiltersStore(nextItems);

    // Mantém compatibilidade: atualiza também o legado com o último filtro usado
    localStorage.setItem(PCP_LEGACY_FILTER_KEY, JSON.stringify(filters));

    alert('Filtro salvo com sucesso!');
  };

  const openLoadSavedFiltersModal = () => {
    refreshSavedFiltersList();
    setOpenSavedFiltersModal(true);
  };

  const confirmLoadSelectedSavedFilter = () => {
    const selected = savedFiltersList.find((i) => i.id === selectedSavedFilterId);
    if (!selected || !selected.filters) return alert('Selecione um filtro válido.');

    applyFiltersPayload(selected.filters);
    localStorage.setItem(PCP_LEGACY_FILTER_KEY, JSON.stringify(selected.filters));

    setOpenSavedFiltersModal(false);
    alert(`Filtro "${selected.name}" carregado com sucesso!`);
  };

  const deleteSelectedSavedFilter = () => {
    const selected = savedFiltersList.find((i) => i.id === selectedSavedFilterId);
    if (!selected) return alert('Selecione um filtro válido.');

    const confirm = window.confirm(`Deseja realmente excluir o filtro "${selected.name}"?`);
    if (!confirm) return;

    // Se for o filtro legado, remove a chave antiga
    if (selected.id === '__legacy__') {
      localStorage.removeItem(PCP_LEGACY_FILTER_KEY);
      refreshSavedFiltersList();
      alert('Filtro antigo (único) excluído com sucesso!');
      return;
    }

    const store = getSavedFiltersStore();
    const nextItems = (store.items || []).filter((i) => i?.id !== selected.id);
    setSavedFiltersStore(nextItems);
    refreshSavedFiltersList();
    alert('Filtro excluído com sucesso!');
  };

  
  useEffect(() => {
    if (filtersLoaded) {
      fetchPCP();
      setFiltersLoaded(false); // reseta o estado após buscar
    }
  }, [filtersLoaded]);
  



  return (
    <div className='pcp-modal'>
      <Header />
      <div className='pcp-tools-container'>

        <input
          type="text"
          value={searchClient}
          onChange={(e) => setSearchClient(e.target.value)}
          placeholder="Pesquisar cliente, pedido, documento, transportador, outro, observações, status carregamento, cidade, @colaborador ou #cor"
          className="client-search-input"
        />

        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="date-filter-input"
        />
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="date-filter-input"
        />

        <button
          className='btn-programacao-producao-pcp'
          onClick={() => setOpenControlesModal(true)}
        >
          Controles {controlePlanejamento.length > 0 && `(${controlePlanejamento.length})`}
        </button>

        <button
          className='btn-programacao-producao-pcp'
          onClick={() => setOpenStatusModal(true)}
        >
          Status {statusFilters[controlePlanejamento[0]]?.length > 0 && `(${statusFilters[controlePlanejamento[0]].length})`}
        </button>

        <button
          className='btn-programacao-producao-pcp'
          onClick={() => setOpenProcessosModal(true)}
        >
          Processos {selectedColumns.length > 0 && `(${selectedColumns.length})`}
        </button>

        <button
          className='btn-programacao-producao-pcp'
          onClick={() => setOpenEntityModal(true)}
        >
          Entidades {selectedEntities.length > 0 && `(${selectedEntities.length})`}
        </button>

        <button className="btn-programacao-producao-pcp" onClick={() => setOpenExportModal(true)} title="Exportar filtrados para Excel">
          <MdDownload size={20} style={{ marginRight: '5px' }} />
        </button>

        <button className="btn-programacao-producao-pcp" onClick={exportFilteredToPDFWithPdfLib} title="Exportar filtrados para PDF">
          <MdPictureAsPdf size={20} style={{ marginRight: '5px' }} />
        </button>

        <button className="btn-programacao-producao-pcp" onClick={() => setOpenResumoModal(true)}>
          <MdBarChart size={20} style={{ marginRight: '5px' }} />
        </button>

        <button
          className="btn-programacao-producao-pcp"
          onClick={fetchPCP}
          title="Atualizar os dados"
        >
          <MdRefresh size={20} style={{ marginRight: '5px' }} />
        </button>






        <button
                  className="btn-programacao-producao-pcp"
                  onClick={saveFiltersToLocalStorage}
                >
                  Salvar Filtros
                </button>

                <button
                  className="btn-programacao-producao-pcp"
                  onClick={openLoadSavedFiltersModal}
                >
                  Carregar Filtros
                </button>
















        {openControlesModal && (
          <div className="modal-controles">
            <div className="modal-controles-content">
              <button className="btn-close" onClick={() => setOpenControlesModal(false)}>✖️</button>
              <h3>Selecionar Controles</h3>
              <div className="controles-list">
                {['medicao', 'producao', 'vidros', 'vistoriaPre', 'entrega', 'instalacao', 'vistoriaPos', 'assistencia'].map((controle) => (
                  <label key={controle} className="controle-option">
                    <input
                      type="checkbox"
                      checked={controlePlanejamento.includes(controle)}
                      onChange={() => handleControleSelection(controle)}
                    />
                    {getControleLabel(controle)}
                  </label>
                ))}
              </div>
              <div className="modal-controles-footer">
                <button
                  className="btn-programacao-producao-pcp"
                  onClick={() => { fetchPCP(); setOpenControlesModal(false) }}
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        )}

        {openSavedFiltersModal && (
          <div className="pcp-savedfilters-modal">
            <div className="pcp-savedfilters-content">
              <button
                className="pcp-savedfilters-close"
                onClick={() => setOpenSavedFiltersModal(false)}
                aria-label="Fechar"
              >
                ✖️
              </button>
              <h3>Carregar Filtro Salvo</h3>

              {savedFiltersList.length === 0 ? (
                <p className="pcp-savedfilters-empty">Nenhum filtro salvo encontrado.</p>
              ) : (
                <>
                  <div className="pcp-savedfilters-list">
                    {savedFiltersList.map((item) => (
                      <label
                        key={item.id}
                        className={`pcp-savedfilters-item ${selectedSavedFilterId === item.id ? 'pcp-savedfilters-item--selected' : ''}`}
                      >
                        <input
                          type="radio"
                          name="pcpSavedFilter"
                          checked={selectedSavedFilterId === item.id}
                          onChange={() => setSelectedSavedFilterId(item.id)}
                        />
                        <div className="pcp-savedfilters-item-info">
                          <div className="pcp-savedfilters-item-name">{item.name}</div>
                          {item.isLegacy ? (
                            <div className="pcp-savedfilters-item-meta">Salvo no formato antigo</div>
                          ) : (
                            <div className="pcp-savedfilters-item-meta">
                              {item.updatedAt ? `Atualizado em ${new Date(item.updatedAt).toLocaleString('pt-BR')}` : ''}
                            </div>
                          )}
                        </div>
                      </label>
                    ))}
                  </div>

                  <div className="pcp-savedfilters-footer">
                    <button className="pcp-savedfilters-select-btn" onClick={confirmLoadSelectedSavedFilter}>
                      Selecionar
                    </button>
                    <button className="pcp-savedfilters-delete" onClick={deleteSelectedSavedFilter}>
                      Excluir
                    </button>
                    <button className="pcp-savedfilters-cancel" onClick={() => setOpenSavedFiltersModal(false)}>
                      Cancelar
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {openStatusModal && (
          <div className="modal-controles">
            <div className="modal-controles-content">
              <button className="btn-close" onClick={() => setOpenStatusModal(false)}>✖️</button>
              <h3>Selecionar Status</h3>
              <div className="controles-list">
                {[
                  { value: 'Parado', label: 'Parado' },
                  { value: 'EmAndamento', label: 'Em Andamento' },
                  { value: 'Parcial', label: 'Parcial' },
                  { value: 'Pronto', label: 'Pronto' }
                ].map((status) => (
                  <label key={status.value} className="controle-option">
                    <input
                      type="checkbox"
                      checked={statusFilters[controlePlanejamento[0]].includes(status.value)}
                      onChange={() => {
                        const currentStatus = statusFilters[controlePlanejamento[0]];
                        const updatedStatus = currentStatus.includes(status.value)
                          ? currentStatus.filter(s => s !== status.value)
                          : [...currentStatus, status.value];

                        const updatedFilters = {
                          ...statusFilters,
                          [controlePlanejamento[0]]: updatedStatus
                        };
                        setStatusFilters(updatedFilters);
                      }}
                    />
                    {status.label}
                  </label>
                ))}
              </div>
              <div className="modal-controles-footer">
                <button
                  className="btn-programacao-producao-pcp"
                  onClick={() => { fetchPCP(); setOpenStatusModal(false) }}
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        )}

        {openProcessosModal && (
          <div className="modal-controles">
            <div className="modal-controles-content">
              <button className="btn-close" onClick={() => setOpenProcessosModal(false)}>✖️</button>
              <h3>Selecionar Processos</h3>
              <div className="controles-list">
                <div className="modal-processos-actions">
                  <button
                    className="btn-action-select"
                    onClick={() => setSelectedColumns(columns.map(col => col.id))}
                  >
                    <span className="icon">✔️</span>
                    <span className="text">Marcar todos</span>
                  </button>
                  <button
                    className="btn-action-select"
                    onClick={() => setSelectedColumns([])}
                  >
                    <span className="icon">❌</span>
                    <span className="text">Desmarcar todos</span>
                  </button>
                </div>
                <div className="search-modal-container">
                  <input
                    type="text"
                    value={searchProcessos}
                    onChange={(e) => setSearchProcessos(e.target.value)}
                    placeholder="Buscar processos..."
                    className="search-modal-input"
                  />
                </div>
                <div className="processos-list">
                  {columns
                    .filter(col => col.name.toLowerCase().includes(searchProcessos.toLowerCase()))
                    .map((col) => (
                      <label key={col.id} className="controle-option">
                        <input
                          type="checkbox"
                          checked={selectedColumns.includes(col.id)}
                          onChange={() => {
                            if (selectedColumns.includes(col.id)) {
                              setSelectedColumns(selectedColumns.filter(id => id !== col.id));
                            } else {
                              setSelectedColumns([...selectedColumns, col.id]);
                            }
                          }}
                        />
                        {col.name}
                      </label>
                    ))}
                </div>
              </div>
              <div className="modal-controles-footer">
                <button
                  className="btn-programacao-producao-pcp"
                  onClick={() => { fetchPCP(); setOpenProcessosModal(false); setSearchProcessos(''); }}
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        )}

        {openEntityModal && (
          <div className="modal-controles">
            <div className="modal-controles-content">
              <button className="btn-close" onClick={() => setOpenEntityModal(false)}>✖️</button>
              <h3>Selecionar Entidades</h3>
              <div className="controles-list">
                <div className="modal-processos-actions">
                  <button
                    className="btn-action-select"
                    onClick={() => setSelectedEntities(listAllUsers.map(user => user.id))}
                  >
                    <span className="icon">✔️</span>
                    <span className="text">Marcar todos</span>
                  </button>
                  <button
                    className="btn-action-select"
                    onClick={() => setSelectedEntities([])}
                  >
                    <span className="icon">❌</span>
                    <span className="text">Desmarcar todos</span>
                  </button>
                </div>
                <div className="search-modal-container">
                  <input
                    type="text"
                    value={searchEntidades}
                    onChange={(e) => setSearchEntidades(e.target.value)}
                    placeholder="Buscar entidades..."
                    className="search-modal-input"
                  />
                </div>
                <div className="processos-list">
                  {listAllUsers
                    .filter(user => user.username.toLowerCase().includes(searchEntidades.toLowerCase()))
                    .map((user) => (
                      <label key={user.id} className="controle-option">
                        <input
                          type="checkbox"
                          checked={selectedEntities.includes(user.id)}
                          onChange={() => {
                            if (selectedEntities.includes(user.id)) {
                              setSelectedEntities(selectedEntities.filter(id => id !== user.id));
                            } else {
                              setSelectedEntities([...selectedEntities, user.id]);
                            }
                          }}
                        />
                        {user.username}
                      </label>
                    ))}
                </div>
              </div>
              <div className="modal-controles-footer">
                <button
                  className="btn-programacao-producao-pcp"
                  onClick={() => { fetchPCP(); setOpenEntityModal(false); setSearchEntidades(''); }}
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        )}

        {openResumoModal && (
          <div className="modal-resumo">
            <div className="modal-resumo-content">
              <button className="btn-close" onClick={() => setOpenResumoModal(false)}>✖️</button>
              <h3>Resumo do Filtro</h3>
              <p><strong>Total de Obras:</strong> {getTotaisFiltrados().totalObras}</p>
              <p><strong>Total de Semanas:</strong> {getTotaisFiltrados().totalSemanas}</p>
              <p><strong>Menor Data:</strong> {getTotaisFiltrados().menorData}</p>
              <p><strong>Maior Data:</strong> {getTotaisFiltrados().maiorData}</p>
              <p><strong>Total de Horas:</strong> {getTotaisFiltrados().totalHoras.toFixed(2)}</p>
              <p><strong>Total de Quadros:</strong> {getTotaisFiltrados().totalQuadros}</p>
              <p><strong>Total de Esquadrias:</strong> {getTotaisFiltrados().totalEsquadrias}</p>
              <p><strong>Total de m²:</strong> {getTotaisFiltrados().totalM2.toFixed(2)}</p>
              {getAccessLevel('valor') && (
                <>
                  <p><strong>Total em Valor:</strong> {getTotaisFiltrados().totalValor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                  <p><strong>Total Valor Etapa:</strong> {getTotaisFiltrados().totalValorEtapa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                </>
              )}
            </div>
          </div>
        )}

        {openExportModal && (
          <div className="modal-controles">
            <div className="modal-controles-content">
              <button className="btn-close" onClick={() => setOpenExportModal(false)}>✖️</button>
              <h3>Opções de Exportação</h3>
              <div className="export-options">
                <div className="export-option">
                  <h4>🚀 Exportar Rápido (Sem Histórico)</h4>
                  <p>Exportação rápida com todos os dados exceto histórico dos cards.</p>
                  <button 
                    className="btn-programacao-producao-pcp export-btn"
                    onClick={exportWithoutHistory}
                  >
                    <MdDownload size={16} style={{ marginRight: '5px' }} />
                    Exportar Rápido
                  </button>
                </div>
                <div className="export-option">
                  <h4>📝 Exportar Completo (Com Histórico)</h4>
                  <p>Exportação completa incluindo histórico detalhado de cada card (pode demorar mais).</p>
                  <button 
                    className="btn-programacao-producao-pcp export-btn"
                    onClick={exportWithHistory}
                  >
                    <MdDownload size={16} style={{ marginRight: '5px' }} />
                    Exportar Completo
                  </button>
                </div>
                <div className="export-option">
                  <h4>🗓️ Exportar Agenda (Semanal)</h4>
                  <p>Planilha simplificada por dia, mantendo todos os filtros aplicados.</p>
                  <button
                    className="btn-programacao-producao-pcp export-btn"
                    onClick={exportWeeklySchedule}
                  >
                    <MdDownload size={16} style={{ marginRight: '5px' }} />
                    Exportar Agenda
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showPreparingModal && (
          <div className="modal-download-backup">
            <div className="modal-download-backup-content">
              <h3>Preparando Documento</h3>
              <p>{loadingResult || 'Preparando documento...'}</p>
            </div>
          </div>
        )}

        {showDownloadModal && (
          <div className="modal-download-backup">
            <div className="modal-download-backup-content">
              <h3>Lembrete de Segurança</h3>
              <p>Recomendamos fazer o download dos dados para garantir que você tenha um backup em caso de problemas de conexão ou internet.</p>
              <p>Antes de fazer o download, lembre-se de selecionar todos os controles e status para ter uma visão completa dos dados.</p>
              <div className="modal-download-backup-actions">
                <button
                  className="btn-close-backup"
                  onClick={() => {
                    setShowDownloadModal(false);
                    setLastDownloadTime(new Date());
                  }}
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        )}










      </div>

      <div className="pcp-container" ref={containerRef}>
        <table className="pcp-table" id="table-to-export">
          <thead>
            <tr className='header-semana-title sticky-header'>
              <th style={{ width: '310px' }}>Card</th>
              <th>Cor</th>
              <th style={{ width: '310px' }}>Observações</th>
              <th>Processo</th>
              <th>Transportador</th>
              <th>Confirmação</th>
              <th style={{ display: 'none' }}>Pedido</th>
              <th>{controlePlanejamento[0] ? controlePlanejamento[0].charAt(0).toUpperCase() + controlePlanejamento[0].slice(1) : ''}</th>
              <th>Entrega</th>
              <th style={{ width: '200px' }} >Colaboradores</th>
              <th style={{ display: 'none' }}>Representante</th>
              {getAccessLevel('valor') &&
                <th>Valor</th>
              }
              {getAccessLevel('valor') &&
                <th>Valor Etapa</th>
              }
              <th>Horas</th>
              <th>Esquadrias</th>
              <th>Quadros</th>
              <th>m2</th>
              <th>Dias de Produção</th>
              <th>Prazo</th>
              <th>Vidro</th>
            </tr>
          </thead>
          <tbody key={tableKey}>
            {renderedCards.length > 0 ? (
              renderTableRows(groupDataByWeek(renderedCards))
            ) : (
              <tr>
                <td colSpan="21" style={{ textAlign: 'center', padding: '20px' }}>
                  Nenhum resultado encontrado para o período selecionado
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

        {openResumoModal && (
        <div className="modal-resumo">
          <div className="modal-resumo-content">
            <button className="btn-close" onClick={() => setOpenResumoModal(false)}>✖️</button>
            <h3>Resumo do Filtro</h3>
            <p><strong>Total de Obras:</strong> {getTotaisFiltrados().totalObras}</p>
            <p><strong>Total de Semanas:</strong> {getTotaisFiltrados().totalSemanas}</p>
            <p><strong>Menor Data:</strong> {getTotaisFiltrados().menorData}</p>
            <p><strong>Maior Data:</strong> {getTotaisFiltrados().maiorData}</p>
            <p><strong>Total de Horas:</strong> {getTotaisFiltrados().totalHoras.toFixed(2)}</p>
            <p><strong>Total de Quadros:</strong> {getTotaisFiltrados().totalQuadros}</p>
            <p><strong>Total de Esquadrias:</strong> {getTotaisFiltrados().totalEsquadrias}</p>
            <p><strong>Total de m²:</strong> {getTotaisFiltrados().totalM2.toFixed(2)}</p>
              {getAccessLevel('valor') && (
                <>
                  <p><strong>Total em Valor:</strong> {getTotaisFiltrados().totalValor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                  <p><strong>Total Valor Etapa:</strong> {getTotaisFiltrados().totalValorEtapa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                </>
              )}
          </div>
        </div>
      )}
    </div>
  );
}

export default PCP;

